import { Injectable, TemplateRef, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Observable, of } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  Enterprise, ParticipantData, companyChampion, Department, Subsidiary, employeeData, asset, client,
  companyStaff, projectRole, Labour, customer
} from '../models/enterprise-model';
import * as moment from 'moment';
import { Project, projectCompDetail, workItem, abridgedBill, Section, subSection, openBksPrj } from '../models/project-model';
import { Task, MomentTask, Unit, Perspective, Objective } from '../models/task-model';
import { academics, classification, coloursUser } from 'app/models/user-model';
import { IsEntry, CF, IS, BS, Asset, EQ, Networth, Invoice } from 'app/models/finances-model';
import { CurrencyPipe } from '@angular/common';
import { agentProduct, compTans, doc, Product, transaction, transCancel } from 'app/models/user';
import { NotificationService } from './notification.service';
import * as stands  from './nyeredzi-data';
// import * as newstands  from './nyeredzi ridge stand sales';
import * as saleData  from './corpfin_stands_data';
import { AngularFirestoreCollection } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';
import { Timestamp } from 'rxjs-compat';
declare var $: any;

@Injectable({
  providedIn: 'root'
})

export class InitialiseService {
  @ViewChild('temp') temp: TemplateRef<any>;
  @ViewChild('template1') template1: TemplateRef<any>;
  @ViewChild('template2') template2: TemplateRef<any>;
  @ViewChild('template6') template6: TemplateRef<any>;
  uzStands = stands;
  // appStands = newstands;
  saleData = saleData;
  textlines = [1,2,3,4];
  textwraps = [1,2,3]; 
  location = '';
  menuPlug = true;
  toolPlug;
  newEquip = false;
  public showEmaiCheck = true;
  task: Task; selectedStaff: ParticipantData;
  openBooksPrj: openBksPrj;
  timedstamp: number;
  type: { value: '', verified: false, approved: false, amount: "", by: "", byId: "", companyId: "", companyName: "",
    createdBy: { name: '', id: ''},  createdOn: "", id: "",  name: "", rate: "", unit: "" }
  selectedProject: Project; userChampion: ParticipantData; compChampion: ParticipantData; selectedCompany: Enterprise;
  newEnterprise: Enterprise; projectCompDetail: { id: string; name: string; }; dpt: Department; employeeData: employeeData;
  workItem: workItem; abridgedBill: abridgedBill; section: Section; asset: asset; client: client; subsidiary: Subsidiary
  contactPerson: ParticipantData; companystaff: companyStaff; department: Department; selectedDepartment: Department;
  classification: classification; public popData: boolean; initColUser: coloursUser; companyWithProjectRoles: projectRole;
  labour: Labour;
  allunits: Unit[] = [];
  SIunits: Unit[];
  projectType: any[];
  country_arr = [];
  toolSet = '';
  module;
  domain: string;
  chatSet = false;
  chatToolset: string;
  onChat = false;
  est = 'TNE1F77IjRzDZr2';
  uni;
  uniInLieu;
  duflowKey = 'srjSRMzLN0NXM';
  isExpense: IsEntry; CF: CF; IS: IS; BalanceSheet: BS; newCS: Asset; newEq: Asset; newNCL: Asset; newCL: Asset; newNCS: Asset; Equity: EQ;
  networth: Networth;
  s_a = [];
  academics: academics;
  profession: academics;
  newTaskPlug = false;
  setSubsection: subSection;
  workClassification = {
    name: 'Work', createdOn: new Date().toISOString(), id: 'colourWorkId', plannedTime: '', actualTime: '',
    Varience: ''
  }
  showFilter = false;
  veds=['3HCyKOzxw8X2FsyXtF0VSuW2fGp2', this.duflowKey+this.est, 'DmKCC9cjXQUWAGyoTvhizfdsKls1'] 
  months = [];
  contact: {
    name: string; id: string; email: string; bus_email: string; phoneNumber: string; photoURL: string; address: string;
    nationalId: string; nationality: string;
  };
  stdPeriods: { id: string; name: string; }[];
  hierarchies = [
    'Executive',
    'Senior management',
    'Middle management',
    'Officer',
    'Operative',
    'None'
  ];

  scorecardWeightStructure = {
    "executive": {
      "executive": {
        "name": "Executive",
        "weighting": 30
      },
      "seniormanagement": {
        "name": "Senior Management",
        "weighting": 40
      },
      "middlemanagement": {
        "name": "Middle Management",  
        "weighting": 15
      },
      "officers": { 
        "name": "Officers",
        "weighting": 10
      },
      "operatives": {
        "name": "Operatives",
        "weighting": 5
      }
    },
    "seniormanagement": {
      "seniormanagement": {
        "name": "Senior Management",
        "weighting": 30
      },
      "middlemanagement": {
        "name": "Middle Management",
        "weighting": 40
      },
      "officers": {
        "name": "Officers",
        "weighting": 20
      },
      "operatives": {
        "name": "Operatives",
        "weighting": 10
      }
    },
    "middlemanagement": {
      "middlemanagement": {
        "name": "Middle Management",
        "weighting": 40
      },
      "officers": {
        "name": "Officers",
        "weighting": 40
      },
      "operatives": {
        "name": "Operatives",
        "weighting": 20
      }
    },
    "officers": {
      "officers": {
        "name": "Officers",
        "weighting": 40
      },
      "operatives": {
        "name": "Operatives",
        "weighting": 60
      }
    },
  }
  booksRoles = [
    'Initiator',
    'Checker',
    'Approver',
    'None'
  ];
  reportType = ['Question & Answers', 'Upload Document'];
  reports = ['Annual Outlook Extract', 'Quarterly Outlook Extract', 'Monthly Outlook Extract', 'Weekly Outlook Extract'];
  upcomingTasksReports = ['Annually Upcoming Tasks', 'Quarterly Upcoming Tasks', 'Monthly Upcoming Tasks', 'Weekly Upcoming Tasks', 'Daily Upcoming Tasks'];
  periods = ['Daily Time Sheet', 'Weekly Time Sheet', 'Any Period'];
  phases = ['All Phases','Phase 1', 'Phase 2'];
  dammy = []
  controls = [
    'Owner', 'Advisor/Consultant', 'Contractor', 'Sub Contractor'
  ];
  rate = { name: '', id: '', unit: '', rate: '', by: '', byId: '', companyName: '', companyId: '', createdOn: '' };
  currencyCodes: string[];
  professions: string[];
  side: boolean;
  millSecs: number;
  randomColor: string;
  inventory: any = { project: { name: '', id: '' }, parent: '', contractSum: { name: '', value: 0 }, rate:  { name: '', verified: false, approved: false } , productNo:  { name: '', verified: false, approved: false }, size: { name: '', verified: false, approved: false }, prjQuantity : { value: 0, name: '' }, unit: { name: '', verified: false, approved: false }, party: {}, Amount: { cost: 0.00, paid: 0.00, balance: 0.00 }, SellStatus: {}, type: { name: '', verified: false, approved: false } }
  area = "\u33A1";
  showColUsers: boolean;
  newUnitfrm: boolean;
  fromClient: boolean;
  postpendHours: boolean;
  newAsset: asset;
  hiredAsset: asset;
  unit: { name: string; id: string; };
  setCompany: { name: any; id: any; };
  teamLabour: any;
  inventoryTypes = [
    { id: 'pstd', name: 'Property(Stand)', type: 'Stand', value: 'Stand' },
    { id: 'phou', name: 'Property(House)', type: 'House', value: 'House' },
  ];
  structuralRoles = [
    { id: 'maincontructactive', name: 'Active Contract Party' },
    { id: 'maincontructsilent', name: 'Main Contract Silent Party' },
    { id: 'subcontract', name: 'Subcontract' },
    { id: 'supplier', name: 'Supplier' },
    { id: 'advisor-agent', name: 'Advisor / Agent' },
    { id: 'customer', name: 'Customer' },
    { id: 'public', name: 'Public' }
  ];
  
  repApp: any = { viewable: ''};
  metApp: any = { viewable: ''};
  notApp: any = { viewable: ''};
  docApp: any = { viewable: ''};
  std: any = { viewable: ''};
  cus: any = { viewable: ''};
  sale: any = { viewable: ''};
  supp: any = { viewable: ''};
  inv: any = { viewable: ''};
  moreprojectInfo: boolean = false;
  moreCustInfo: boolean = false;

//!Payments
  selectedStand: number;
  selectedType: string;
  selectedMethod: string;
  selectedCustomer: string;
  selectedTrans: string;
  selectedDuration: string;

 
typeOfSales = [
  {
    id: 1, name: "Cash Sale",
  },
  {
    id: 2, name: "Credit Sale"
  }
];

transClass = [
    "Credit", "Debit"
];

  paymentMethod = [ "Cash", "Product" ];

  instalmentplan = [ "OnceOff", "Monthly", "Quarterly", "Yearly" ]


  // sales
  customerTypes = [
    {
      id: 1 , name: "Individual",
    },
    {
      id: 2, name: "Company"
    },
   
  ];

  instalmentTypes = [
    {
      id: 1, name: "Monthly",
    },
    {
      id: 2, name: "Quarterly"
    },
    {
      id: 3, name: "Yearly"
    }
  ];

  payement = {
    customer: null, supplier: null, product: '', duration: '',method: '', amountPaid: null, amountDue: null, productRate: { amount: '', unit: null }, quantityInLieu: null, products: [], balance: '', date: ''
  };
  message: any;
  counter$: any;
  subscription: any;
  ent: any;
  selected = false;
  showPeriod = false;
  currency: any;
    updatePartyTimes: boolean;
  time: string;
  modalRef: any;
  modalRef2: any;
  perspective: Perspective;
  objective: Objective;
  
  constructor(public ns: NotificationService, public modalService: NgbModal, private currencyPipe : CurrencyPipe) {
    // console.log(this.appStands.stands);
    this.type = { value: '', verified: false, approved: false, amount: "", by: "", byId: "", companyId: "", companyName: "", createdBy: { name: '', id: ''},  createdOn: "", id: "",  name: "", rate: "", unit: "" }
    this.toolPlug = true;
    this.module = '';
    this.counter$ = Observable.interval(1000).map((x) => {
      return Math.floor((this.timedstamp - new Date().getTime()) / 1000);
    });
    this.subscription = this.counter$.subscribe((x) => this.message = this.dhms());
    this.currency = [
      {
        symbol: "CA$",
        name: "Canadian Dollar (CA$)",
        symbol_native: "$",
        decimal_digits: 2,
        rounding: 0,
        code: "CAD",
        name_plural: "Canadian dollars"
      }, {
        symbol: "€",
        name: "Euro (€)",
        symbol_native: "€",
        decimal_digits: 2,
        rounding: 0,
        code: "EUR",
        name_plural: "euros"
      }, {
        symbol: "R",
        name: "South African Rand (R)",
        symbol_native: "R",
        decimal_digits: 2,
        rounding: 0,
        code: "ZAR",
        name_plural: "South African rand"
      }, {
        symbol: "$",
        name: "US Dollar (USD)",
        symbol_native: "$",
        decimal_digits: 2,
        rounding: 0,
        code: "USD",
        name_plural: "US dollars"
      }, {
        symbol: "ZWL$",
        name: "Zimbabwean Dollar (ZWL$)",
        symbol_native: "ZWL$",
        decimal_digits: 0,
        rounding: 0,
        code: "ZWL",
        name_plural: "Zimbabwean Dollar"
      }
    ];
    this.allunits = [
      { id: 'm2', name: `Area(meters2)` , unicode : "\u33A1" },
      { id: 'ac', name: 'Area(Acres)', unicode: 'ac' },
      { id: 'ha', name: 'Area(Hactares)', unicode: "\u33CA"},
      { id: 'm3', name: 'Volume(\u33A5)' , unicode : "\u33A5" },
      { id: 'mi', name: 'Miles(mi)' , unicode : "mi"},
      { id: 'item(s)', name: 'Items', unicode: 'item(s)' },
      { id: 'minutes(s)', name: 'Time(minutes/s)' , unicode:' min(s)' },
      { id: 'hour(s)', name: 'Time(hour/s)', unicode: 'hr(s)' },
      { id: 'day(s)', name: 'Time(day/s)', unicode:' day(s)' },
      { id: 'week(s)', name: 'Time(week/s)', unicode: 'week(s)' },
      { id: 'month(s)', name: 'Time(month/s)' , unicode: 'month(s)' },
      { id: 'year(s)', name: 'Time(year/s)', unicode: 'year(s)' },
      { id: 'line(s)', name: 'Line/s', unicode: 'line(s)' },
      { id: 'kg', name: 'Kilograms(\u338F)' , unicode: "\u338F" },
      { id: 'yd', name: 'Yards(yd)',  unicode : 'yd', },
      { id: 'mm', name: 'Millimeters(\u339C)' ,unicode: "\u339C" },
      { id: 'cm', name: 'Centimeters(\u339D)' , unicode: "\u339D"} ,
      { id: 'm', name: 'Meters(m)' , unicode : 'm'},
      { id: 'Km', name: 'Kilometers(\u33A2)' , unicode: "\u33A2" },
      { id: 'inchie(s)', name: 'Inches(\u33CC)' , unicode: "\u33CC"},
      { id: 'ft', name: 'Feet(ft)',  unicode : 'ft'},
      { id: 'g', name: 'Grams(g)', unicode: 'g'},
      { id: 'ZWL', name: 'Zim dollar($)' ,unicode: 'ZWL'},
      { id: 'USD', name: 'American dollar($)', unicode: 'USD' }, 
      { id: 'Rands', name: 'South African Rands(R)', unicode: 'Rands'}
    ];
    this.projectType = [
      { id: 'Personal', name: 'Personal' },
      { id: 'Enterprise', name: 'Enterprise' }
    ];
    this.country_arr = [{ id: 'Afghanistan', name: 'Afghanistan' }, { id: 'Albania', name: 'Albania' }, { id: 'Algeria', name: 'Algeria' },
    { id: 'American Samoa', name: 'American Samoa' }, { id: 'Angola', name: 'Angola' }, { id: 'Anguilla', name: 'Anguilla' },
    { id: 'Antartica', name: 'Antartica' }, { id: 'Antigua and Barbuda', name: 'Antigua and Barbuda' }, {
      id: 'Argentina',
      name: 'Argentina'
    }, { id: 'Armenia', name: 'Armenia' }, { id: 'Aruba', name: 'Aruba' }, {
      id: 'Ashmore and Cartier Island',
      name: 'Ashmore and Cartier Island'
    }, { id: 'Australia', name: 'Australia' }, { id: 'Austria', name: 'Austria' }, {
      id: 'Azerbaijan',
      name: 'Azerbaijan'
    }, { id: 'Bahamas', name: 'Bahamas' }, { id: 'Bahrain', name: 'Bahrain' }, { id: 'Bangladesh', name: 'Bangladesh' },
    { id: 'Barbados', name: 'Barbados' }, { id: 'Belarus', name: 'Belarus' }, { id: 'Belgium', name: 'Belgium' }, { id: 'Belize', name: 'Belize' },
    { id: 'Benin', name: 'Benin' }, { id: 'Bermuda', name: 'Bermuda' }, { id: 'Bhutan', name: 'Bhutan' },
    { id: 'Bolivia', name: 'Bolivia' },
    { id: 'Bosnia and Herzegovina', name: 'Bosnia and Herzegovina' }, { id: 'Botswana', name: 'Botswana' },
    { id: 'Brazil', name: 'Brazil' }, { id: 'British Virgin Islands', name: 'British Virgin Islands' }, { id: 'Brunei', name: 'Brunei' },
    { id: 'Bulgaria', name: 'Bulgaria' }, { id: 'Burkina Faso', name: 'Burkina Faso' }, { id: 'Burma', name: 'Burma' }, {
      id: 'Burundi',
      name: 'Burundi'
    }, { id: 'Cambodia', name: 'Cambodia' }, { id: 'Cameroon', name: 'Cameroon' }, { id: 'Canada', name: 'Canada' },
    { id: 'Cape Verde', name: 'Cape Verde' }, { id: 'Cayman Islands', name: 'Cayman Islands' }, {
      id: 'Central African Republic',
      name: 'Central African Republic'
    }, { id: 'Chad', name: 'Chad' }, { id: 'Chile', name: 'Chile' }, { id: 'China', name: 'China' }, { id: 'Christmas Island', name: 'Christmas Island' }, { id: 'Clipperton Island', name: 'Clipperton Island' },
    { id: 'Cocos (Keeling) Islands', name: 'Cocos (Keeling) Islands' }, { id: 'Colombia', name: 'Colombia' },
    { id: 'Comoros', name: 'Comoros' },
    { id: 'Democratic Republic of the Congo', name: 'Democratic Republic of the Congo' }, { id: 'Cook Islands', name: 'Cook Islands' },
    { id: 'Costa Rica', name: 'Costa Rica' }, { id: 'Cote d\'Ivoire', name: 'Cote d\'Ivoire' },
    { id: 'Croatia', name: 'Croatia' }, { id: 'Cuba', name: 'Cuba' }, { id: 'Cyprus', name: 'Cyprus' }, { id: 'Czeck Republic', name: 'Czeck Republic' }, { id: 'Denmark', name: 'Denmark' }, { id: 'Djibouti', name: 'Djibouti' }, { id: 'Dominica', name: 'Dominica' }, { id: 'Dominican Republic', name: 'Dominican Republic' }, { id: 'Ecuador', name: 'Ecuador' }, { id: 'Egypt', name: 'Egypt' },
    { id: 'El Salvador', name: 'El Salvador' }, { id: 'Equatorial Guinea', name: 'Equatorial Guinea' }, { id: 'Eritrea', name: 'Eritrea' },
    { id: 'Estonia', name: 'Estonia' }, { id: 'Ethiopia', name: 'Ethiopia' }, { id: 'Europa Island', name: 'Europa Island' }, { id: 'Falkland Islands (Islas Malvinas)', name: 'Falkland Islands (Islas Malvinas)' }, { id: 'Faroe Islands', name: 'Faroe Islands' },
    { id: 'Fiji', name: 'Fiji' }, { id: 'Finland', name: 'Finland' }, { id: 'France', name: 'France' }, { id: 'French Guiana', name: 'French Guiana' }, { id: 'French Polynesia', name: 'French Polynesia' }, { id: 'French Southern and Antarctic Lands', name: 'French Southern and Antarctic Lands' }, { id: 'Gabon', name: 'Gabon' }, { id: 'Gambia', name: 'Gambia' }, { id: 'Gaza Strip', name: 'The Gaza Strip' },
    { id: 'Georgia', name: 'Georgia' }, { id: 'Germany', name: 'Germany' }, { id: 'Ghana', name: 'Ghana' }, { id: 'Gibraltar', name: 'Gibraltar' }, { id: 'Glorioso Islands', name: 'Glorioso Islands' }, { id: 'Greece', name: 'Greece' }, { id: 'Greenland', name: 'Greenland' }, { id: 'Grenada', name: 'Grenada' }, { id: 'Guadeloupe', name: 'Guadeloupe' }, { id: 'Guam', name: 'Guam' },
    { id: 'Guatemala', name: 'Guatemala' }, { id: 'Guernsey', name: 'Guernsey' }, { id: 'Guinea', name: 'Guinea' }, {
      id: 'Guinea-Bissau',
      name: 'Guinea-Bissau'
    }, { id: 'Guyana', name: 'Guyana' }, { id: 'Haiti', name: 'Haiti' }, { id: 'Heard Island and McDonald Islands', name: 'Heard Island and McDonald Islands' }, { id: 'Holy See (Vatican City)', name: 'Holy See (Vatican City)' },
    { id: 'Honduras', name: 'Honduras' }, { id: 'Hong Kong', name: 'Hong Kong' }, { id: 'Howland Island', name: 'Howland Island' }, { id: 'Hungary', name: 'Hungary' }, { id: 'Iceland', name: 'Iceland' }, { id: 'India', name: 'India' }, { id: 'Indonesia', name: 'Indonesia' }, { id: 'Iran', name: 'Iran' }, { id: 'Iraq', name: 'Iraq' }, { id: 'Ireland', name: 'Ireland' },
    { id: 'Northern Ireland', name: 'Northern Ireland' }, { id: 'Israel', name: 'Israel' }, { id: 'Italy', name: 'Italy' }, {
      id: 'Jamaica',
      name: 'Jamaica'
    }, { id: 'Jan Mayen', name: 'Jan Mayen' }, { id: 'Japan', name: 'Japan' }, { id: 'Jarvis Island', name: 'Jarvis Island' },
    { id: 'Jersey', name: 'Jersey' }, { id: 'Johnston Atoll', name: 'Johnston Atoll' }, { id: 'Jordan', name: 'Jordan' },
    { id: 'Juan de Nova Island', name: 'Juan de Nova Island' }, { id: 'Kazakhstan', name: 'Kazakhstan' }, { id: 'Kenya', name: 'Kenya' },
    { id: 'Kiribati', name: 'Kiribati' }, { id: 'North Korea', name: 'North Korea' }, { id: 'South Korea', name: 'South Korea' }, { id: 'Kuwait', name: 'Kuwait' }, { id: 'Kyrgyzstan', name: 'Kyrgyzstan' }, { id: 'Laos', name: 'Laos' }, { id: 'Latvia', name: 'Latvia' },
    { id: 'Lebanon', name: 'Lebanon' }, { id: 'Lesotho', name: 'Lesotho' }, { id: 'Liberia', name: 'Liberia' }, {
      id: 'Libya',
      name: 'Libya'
    },
    { id: 'Liechtenstein', name: 'Liechtenstein' }, { id: 'Lithuania', name: 'Lithuania' }, { id: 'Luxembourg', name: 'Luxembourg' }, { id: 'Macau', name: 'Macau' }, { id: 'Former Yugoslav Republic of Macedonia', name: 'Former Yugoslav Republic of Macedonia' },
    { id: 'Madagascar', name: 'Madagascar' }, { id: 'Malawi', name: 'Malawi' }, { id: 'Malaysia', name: 'Malaysia' }, {
      id: 'Maldives',
      name: 'Maldives'
    }, { id: 'Mali', name: 'Mali' }, { id: 'Malta', name: 'Malta' }, { id: 'Isle of Man', name: 'Isle of Man' }, {
      id: 'Marshall Islands',
      name: 'Marshall Islands'
    }, { id: 'Martinique', name: 'Martinique' }, { id: 'Mauritania', name: 'Mauritania' },
    { id: 'Mauritius', name: 'Mauritius' }, { id: 'Mayotte', name: 'Mayotte' }, { id: 'Mexico', name: 'Mexico' }, { id: 'Federated States of Micronesia', name: 'Federated States of Micronesia' }, { id: 'Midway Islands', name: 'Midway Islands' }, { id: 'Moldova', name: 'Moldova' }, { id: 'Monaco', name: 'Monaco' }, { id: 'Mongolia', name: 'Mongolia' }, { id: 'Montserrat', name: 'Montserrat' },
    { id: 'Morocco', name: 'Morocco' }, { id: 'Mozambique', name: 'Mozambique' }, { id: 'Namibia', name: 'Namibia' }, { id: 'Nauru', name: 'Nauru' }, { id: 'Nepal', name: 'Nepal' }, { id: 'Netherlands', name: 'Netherlands' }, { id: 'Netherlands Antilles', name: 'Netherlands Antilles' }, { id: 'New Caledonia', name: 'New Caledonia' }, { id: 'New Zealand', name: 'New Zealand' },
    { id: 'Nicaragua', name: 'Nicaragua' }, { id: 'Niger', name: 'Niger' }, { id: 'Nigeria', name: 'Nigeria' },
    { id: 'Niue', name: 'Niue' },
    { id: 'Norfolk Island', name: 'Norfolk Island' }, { id: 'Northern Mariana Islands', name: 'Northern Mariana Islands' },
    { id: 'Norway', name: 'Norway' }, { id: 'Oman', name: 'Oman' }, { id: 'Pakistan', name: 'Pakistan' }, { id: 'Palau', name: 'Palau' },
    { id: 'Panama', name: 'Panama' }, { id: 'Papua New Guinea', name: 'Papua New Guinea' }, { id: 'Paraguay', name: 'Paraguay' },
    { id: 'Peru', name: 'Peru' }, { id: 'Philippines', name: 'Philippines' }, { id: 'Pitcaim Islands', name: 'Pitcaim Islands' }, { id: 'Poland', name: 'Poland' }, { id: 'Portugal', name: 'Portugal' }, { id: 'Puerto Rico', name: 'Puerto Rico' }, { id: 'Qatar', name: 'Qatar' },
    { id: 'Reunion', name: 'Reunion' }, { id: 'Romainia', name: 'Romainia' }, { id: 'Russia', name: 'Russia' }, {
      id: 'Rwanda',
      name: 'Rwanda'
    }, { id: 'Saint Helena', name: 'Saint Helena' }, { id: 'aint Kitts and Nevis', name: 'Saint Kitts and Nevis' }, {
      id: 'Saint Lucia',
      name: 'Saint Lucia'
    }, { id: 'Saint Pierre and Miquelon', name: 'Saint Pierre and Miquelon' },
    { id: 'Saint Vincent and the Grenadines', name: 'Saint Vincent and the Grenadines' }, { id: 'Samoa', name: 'Samoa' },
    { id: 'San Marino', name: 'San Marino' }, { id: 'Sao Tome and Principe', name: 'Sao Tome and Principe' }, { id: 'Saudi Arabia', name: 'Saudi Arabia' }, { id: 'Scotland', name: 'Scotland' }, { id: 'Senegal', name: 'Senegal' }, { id: 'Seychelles', name: 'Seychelles' },
    { id: 'Sierra Leone', name: 'Sierra Leone' }, { id: 'Singapore', name: 'Singapore' }, { id: 'Slovakia', name: 'Slovakia' }, { id: 'Slovenia', name: 'Slovenia' }, { id: 'Solomon Islands', name: 'Solomon Islands' }, { id: 'Somalia', name: 'Somalia' }, { id: 'South Africa', name: 'South Africa' }, { id: 'South Georgia and South Sandwich Islands', name: 'South Georgia and South Sandwich Islands' },
    { id: 'Spain', name: 'Spain' }, { id: 'Spratly Islands', name: 'Spratly Islands' }, { id: 'Sri Lanka', name: 'Sri Lanka' },
    { id: 'Sudan', name: 'Sudan' }, { id: 'Suriname', name: 'Suriname' }, { id: 'Svalbard', name: 'Svalbard' }, { id: 'Swaziland', name: 'Swaziland' }, { id: 'Sweden', name: 'Sweden' }, { id: 'Switzerland', name: 'Switzerland' }, { id: 'Syria', name: 'Syria' },
    { id: 'Taiwan', name: 'Taiwan' }, { id: 'Tajikistan', name: 'Tajikistan' }, { id: 'Tanzania', name: 'Tanzania' },
    { id: 'Thailand', name: 'Thailand' }, { id: 'Tobago', name: 'Tobago' }, { id: 'Toga', name: 'Toga' },
    { id: 'Tokelau', name: 'Tokelau' },
    { id: 'Tonga', name: 'Tonga' }, { id: 'Trinidad', name: 'Trinidad' }, { id: 'Tunisia', name: 'Tunisia' },
    { id: 'Turkey', name: 'Turkey' },
    { id: 'Turkmenistan', name: 'Turkmenistan' }, { id: 'Tuvalu', name: 'Tuvalu' }, { id: 'Uganda', name: 'Uganda' }, { id: 'Ukraine', name: 'Ukraine' }, { id: 'United Arab Emirates', name: 'United Arab Emirates' }, { id: 'United Kingdom', name: 'United Kingdom' }, { id: 'Uruguay', name: 'Uruguay' }, { id: 'USA', name: 'USA' }, { id: 'Uzbekistan', name: 'Uzbekistan' },
    { id: '', name: 'Vanuatu' }, { id: 'Venezuela', name: 'Venezuela' }, { id: 'Vietnam', name: 'Vietnam' }, { id: 'Virgin Islands', name: 'Virgin Islands' }, { id: 'Wales', name: 'Wales' }, { id: 'Wallis and Futuna', name: 'Wallis and Futuna' }, { id: 'West Bank', name: 'West Bank' }, { id: 'Western Sahara', name: 'Western Sahara' }, { id: 'Yemen', name: 'Yemen' },
    { id: 'Yugoslavia', name: 'Yugoslavia' }, { id: 'Zambia', name: 'Zambia' }, { id: 'Zimbabwe', name: 'Zimbabwe' }];
    this.s_a[0] = '';
    this.s_a[1] = 'Badakhshan|Badghis|Baghlan|Balkh|Bamian|Farah|Faryab|Ghazni|Ghowr|Helmand|Herat|Jowzjan|Kabol|Kandahar|Kapisa|Konar|Kondoz|Laghman|Lowgar|Nangarhar|Nimruz|Oruzgan|Paktia|Paktika|Parvan|Samangan|Sar-e Pol|Takhar|Vardak|Zabol';
    this.s_a[2] = 'Berat|Bulqize|Delvine|Devoll (Bilisht)|Diber (Peshkopi)|Durres|Elbasan|Fier|Gjirokaster|Gramsh|Has (Krume)|Kavaje|Kolonje (Erseke)|Korce|Kruje|Kucove|Kukes|Kurbin|Lezhe|Librazhd|Lushnje|Malesi e Madhe (Koplik)|Mallakaster (Ballsh)|Mat (Burrel)|Mirdite (Rreshen)|Peqin|Permet|Pogradec|Puke|Sarande|Shkoder|Skrapar (Corovode)|Tepelene|Tirane (Tirana)|Tirane (Tirana)|Tropoje (Bajram Curri)|Vlore';
    this.s_a[3] = 'Adrar|Ain Defla|Ain Temouchent|Alger|Annaba|Batna|Bechar|Bejaia|Biskra|Blida|Bordj Bou Arreridj|Bouira|Boumerdes|Chlef|Constantine|Djelfa|El Bayadh|El Oued|El Tarf|Ghardaia|Guelma|Illizi|Jijel|Khenchela|Laghouat|M\'Sila|Mascara|Medea|Mila|Mostaganem|Naama|Oran|Ouargla|Oum el Bouaghi|Relizane|Saida|Setif|Sidi Bel Abbes|Skikda|Souk Ahras|Tamanghasset|Tebessa|Tiaret|Tindouf|Tipaza|Tissemsilt|Tizi Ouzou|Tlemcen';
    this.s_a[4] = 'Eastern|Manu\'a|Rose Island|Swains Island|Western';
    this.s_a[5] = 'Andorra la Vella|Bengo|Benguela|Bie|Cabinda|Canillo|Cuando Cubango|Cuanza Norte|Cuanza Sul|Cunene|Encamp|Escaldes-Engordany|Huambo|Huila|La Massana|Luanda|Lunda Norte|Lunda Sul|Malanje|Moxico|Namibe|Ordino|Sant Julia de Loria|Uige|Zaire';
    this.s_a[6] = 'Anguilla';
    this.s_a[7] = 'Antartica';
    this.s_a[8] = 'Barbuda|Redonda|Saint George|Saint John|Saint Mary|Saint Paul|Saint Peter|Saint Philip';
    this.s_a[9] = 'Antartica e Islas del Atlantico Sur|Buenos Aires|Buenos Aires Capital Federal|Catamarca|Chaco|Chubut|Cordoba|Corrientes|Entre Rios|Formosa|Jujuy|La Pampa|La Rioja|Mendoza|Misiones|Neuquen|Rio Negro|Salta|San Juan|San Luis|Santa Cruz|Santa Fe|Santiago del Estero|Tierra del Fuego|Tucuman';
    this.s_a[10] = 'Aragatsotn|Ararat|Armavir|Geghark\'unik\'|Kotayk\'|Lorri|Shirak|Syunik\'|Tavush|Vayots\' Dzor|Yerevan';
    this.s_a[11] = 'Aruba';
    this.s_a[12] = 'Ashmore and Cartier Island';
    this.s_a[13] = 'Australian Capital Territory|New South Wales|Northern Territory|Queensland|South Australia|Tasmania|Victoria|Western Australia';
    this.s_a[14] = 'Burgenland|Kaernten|Niederoesterreich|Oberoesterreich|Salzburg|Steiermark|Tirol|Vorarlberg|Wien';
    this.s_a[15] = 'Abseron Rayonu|Agcabadi Rayonu|Agdam Rayonu|Agdas Rayonu|Agstafa Rayonu|Agsu Rayonu|Ali Bayramli Sahari|Astara Rayonu|Baki Sahari|Balakan Rayonu|Barda Rayonu|Beylaqan Rayonu|Bilasuvar Rayonu|Cabrayil Rayonu|Calilabad Rayonu|Daskasan Rayonu|Davaci Rayonu|Fuzuli Rayonu|Gadabay Rayonu|Ganca Sahari|Goranboy Rayonu|Goycay Rayonu|Haciqabul Rayonu|Imisli Rayonu|Ismayilli Rayonu|Kalbacar Rayonu|Kurdamir Rayonu|Lacin Rayonu|Lankaran Rayonu|Lankaran Sahari|Lerik Rayonu|Masalli Rayonu|Mingacevir Sahari|Naftalan Sahari|Naxcivan Muxtar Respublikasi|Neftcala Rayonu|Oguz Rayonu|Qabala Rayonu|Qax Rayonu|Qazax Rayonu|Qobustan Rayonu|Quba Rayonu|Qubadli Rayonu|Qusar Rayonu|Saatli Rayonu|Sabirabad Rayonu|Saki Rayonu|Saki Sahari|Salyan Rayonu|Samaxi Rayonu|Samkir Rayonu|Samux Rayonu|Siyazan Rayonu|Sumqayit Sahari|Susa Rayonu|Susa Sahari|Tartar Rayonu|Tovuz Rayonu|Ucar Rayonu|Xacmaz Rayonu|Xankandi Sahari|Xanlar Rayonu|Xizi Rayonu|Xocali Rayonu|Xocavand Rayonu|Yardimli Rayonu|Yevlax Rayonu|Yevlax Sahari|Zangilan Rayonu|Zaqatala Rayonu|Zardab Rayonu';
    this.s_a[16] = 'Acklins and Crooked Islands|Bimini|Cat Island|Exuma|Freeport|Fresh Creek|Governor\'s Harbour|Green Turtle Cay|Harbour Island|High Rock|Inagua|Kemps Bay|Long Island|Marsh Harbour|Mayaguana|New Providence|Nicholls Town and Berry Islands|Ragged Island|Rock Sound|San Salvador and Rum Cay|Sandy Point';
    this.s_a[17] = 'Al Hadd|Al Manamah|Al Mintaqah al Gharbiyah|Al Mintaqah al Wusta|Al Mintaqah ash Shamaliyah|Al Muharraq|Ar Rifa\' wa al Mintaqah al Janubiyah|Jidd Hafs|Juzur Hawar|Madinat \'Isa|Madinat Hamad|Sitrah';
    this.s_a[18] = 'Barguna|Barisal|Bhola|Jhalokati|Patuakhali|Pirojpur|Bandarban|Brahmanbaria|Chandpur|Chittagong|Comilla|Cox\'s Bazar|Feni|Khagrachari|Lakshmipur|Noakhali|Rangamati|Dhaka|Faridpur|Gazipur|Gopalganj|Jamalpur|Kishoreganj|Madaripur|Manikganj|Munshiganj|Mymensingh|Narayanganj|Narsingdi|Netrokona|Rajbari|Shariatpur|Sherpur|Tangail|Bagerhat|Chuadanga|Jessore|Jhenaidah|Khulna|Kushtia|Magura|Meherpur|Narail|Satkhira|Bogra|Dinajpur|Gaibandha|Jaipurhat|Kurigram|Lalmonirhat|Naogaon|Natore|Nawabganj|Nilphamari|Pabna|Panchagarh|Rajshahi|Rangpur|Sirajganj|Thakurgaon|Habiganj|Maulvi bazar|Sunamganj|Sylhet';
    this.s_a[19] = 'Bridgetown|Christ Church|Saint Andrew|Saint George|Saint James|Saint John|Saint Joseph|Saint Lucy|Saint Michael|Saint Peter|Saint Philip|Saint Thomas';
    this.s_a[20] = 'Brestskaya (Brest)|Homyel\'skaya (Homyel\')|Horad Minsk|Hrodzyenskaya (Hrodna)|Mahilyowskaya (Mahilyow)|Minskaya|Vitsyebskaya (Vitsyebsk)';
    this.s_a[21] = 'Antwerpen|Brabant Wallon|Brussels Capitol Region|Hainaut|Liege|Limburg|Luxembourg|Namur|Oost-Vlaanderen|Vlaams Brabant|West-Vlaanderen';
    this.s_a[22] = 'Belize|Cayo|Corozal|Orange Walk|Stann Creek|Toledo';
    this.s_a[23] = 'Alibori|Atakora|Atlantique|Borgou|Collines|Couffo|Donga|Littoral|Mono|Oueme|Plateau|Zou';
    this.s_a[24] = 'Devonshire|Hamilton|Hamilton|Paget|Pembroke|Saint George|Saint Georges|Sandys|Smiths|Southampton|Warwick';
    this.s_a[25] = 'Bumthang|Chhukha|Chirang|Daga|Geylegphug|Ha|Lhuntshi|Mongar|Paro|Pemagatsel|Punakha|Samchi|Samdrup Jongkhar|Shemgang|Tashigang|Thimphu|Tongsa|Wangdi Phodrang';
    this.s_a[26] = 'Beni|Chuquisaca|Cochabamba|La Paz|Oruro|Pando|Potosi|Santa Cruz|Tarija';
    this.s_a[27] = 'Federation of Bosnia and Herzegovina|Republika Srpska';
    this.s_a[28] = 'Central|Chobe|Francistown|Gaborone|Ghanzi|Kgalagadi|Kgatleng|Kweneng|Lobatse|Ngamiland|North-East|Selebi-Pikwe|South-East|Southern';
    this.s_a[29] = 'Acre|Alagoas|Amapa|Amazonas|Bahia|Ceara|Distrito Federal|Espirito Santo|Goias|Maranhao|Mato Grosso|Mato Grosso do Sul|Minas Gerais|Para|Paraiba|Parana|Pernambuco|Piaui|Rio de Janeiro|Rio Grande do Norte|Rio Grande do Sul|Rondonia|Roraima|Santa Catarina|Sao Paulo|Sergipe|Tocantins';
    this.s_a[30] = 'Anegada|Jost Van Dyke|Tortola|Virgin Gorda';
    this.s_a[31] = 'Belait|Brunei and Muara|Temburong|Tutong';
    this.s_a[32] = 'Blagoevgrad|Burgas|Dobrich|Gabrovo|Khaskovo|Kurdzhali|Kyustendil|Lovech|Montana|Pazardzhik|Pernik|Pleven|Plovdiv|Razgrad|Ruse|Shumen|Silistra|Sliven|Smolyan|Sofiya|Sofiya-Grad|Stara Zagora|Turgovishte|Varna|Veliko Turnovo|Vidin|Vratsa|Yambol';
    this.s_a[33] = 'Bale|Bam|Banwa|Bazega|Bougouriba|Boulgou|Boulkiemde|Comoe|Ganzourgou|Gnagna|Gourma|Houet|Ioba|Kadiogo|Kenedougou|Komandjari|Kompienga|Kossi|Koupelogo|Kouritenga|Kourweogo|Leraba|Loroum|Mouhoun|Nahouri|Namentenga|Naumbiel|Nayala|Oubritenga|Oudalan|Passore|Poni|Samentenga|Sanguie|Seno|Sissili|Soum|Sourou|Tapoa|Tuy|Yagha|Yatenga|Ziro|Zondomo|Zoundweogo';
    this.s_a[34] = 'Ayeyarwady|Bago|Chin State|Kachin State|Kayah State|Kayin State|Magway|Mandalay|Mon State|Rakhine State|Sagaing|Shan State|Tanintharyi|Yangon';
    this.s_a[35] = 'Bubanza|Bujumbura|Bururi|Cankuzo|Cibitoke|Gitega|Karuzi|Kayanza|Kirundo|Makamba|Muramvya|Muyinga|Mwaro|Ngozi|Rutana|Ruyigi';
    this.s_a[36] = 'Banteay Mean Cheay|Batdambang|Kampong Cham|Kampong Chhnang|Kampong Spoe|Kampong Thum|Kampot|Kandal|Kaoh Kong|Keb|Kracheh|Mondol Kiri|Otdar Mean Cheay|Pailin|Phnum Penh|Pouthisat|Preah Seihanu (Sihanoukville)|Preah Vihear|Prey Veng|Rotanah Kiri|Siem Reab|Stoeng Treng|Svay Rieng|Takev';
    this.s_a[37] = 'Adamaoua|Centre|Est|Extreme-Nord|Littoral|Nord|Nord-Ouest|Ouest|Sud|Sud-Ouest';
    this.s_a[38] = 'Alberta|British Columbia|Manitoba|New Brunswick|Newfoundland|Northwest Territories|Nova Scotia|Nunavut|Ontario|Prince Edward Island|Quebec|Saskatchewan|Yukon Territory';
    this.s_a[39] = 'Boa Vista|Brava|Maio|Mosteiros|Paul|Porto Novo|Praia|Ribeira Grande|Sal|Santa Catarina|Santa Cruz|Sao Domingos|Sao Filipe|Sao Nicolau|Sao Vicente|Tarrafal';
    this.s_a[40] = 'Creek|Eastern|Midland|South Town|Spot Bay|Stake Bay|West End|Western';
    this.s_a[41] = 'Bamingui-Bangoran|Bangui|Basse-Kotto|Gribingui|Haut-Mbomou|Haute-Kotto|Haute-Sangha|Kemo-Gribingui|Lobaye|Mbomou|Nana-Mambere|Ombella-Mpoko|Ouaka|Ouham|Ouham-Pende|Sangha|Vakaga';
    this.s_a[42] = 'Batha|Biltine|Borkou-Ennedi-Tibesti|Chari-Baguirmi|Guera|Kanem|Lac|Logone Occidental|Logone Oriental|Mayo-Kebbi|Moyen-Chari|Ouaddai|Salamat|Tandjile';
    this.s_a[43] = 'Aisen del General Carlos Ibanez del Campo|Antofagasta|Araucania|Atacama|Bio-Bio|Coquimbo|Libertador General Bernardo O\'Higgins|Los Lagos|Magallanes y de la Antartica Chilena|Maule|Region Metropolitana (Santiago)|Tarapaca|Valparaiso';
    this.s_a[44] = 'Anhui|Beijing|Chongqing|Fujian|Gansu|Guangdong|Guangxi|Guizhou|Hainan|Hebei|Heilongjiang|Henan|Hubei|Hunan|Jiangsu|Jiangxi|Jilin|Liaoning|Nei Mongol|Ningxia|Qinghai|Shaanxi|Shandong|Shanghai|Shanxi|Sichuan|Tianjin|Xinjiang|Xizang (Tibet)|Yunnan|Zhejiang';
    this.s_a[45] = 'Christmas Island';
    this.s_a[46] = 'Clipperton Island';
    this.s_a[47] = 'Direction Island|Home Island|Horsburgh Island|North Keeling Island|South Island|West Island';
    this.s_a[48] = 'Amazonas|Antioquia|Arauca|Atlantico|Bolivar|Boyaca|Caldas|Caqueta|Casanare|Cauca|Cesar|Choco|Cordoba|Cundinamarca|Distrito Capital de Santa Fe de Bogota|Guainia|Guaviare|Huila|La Guajira|Magdalena|Meta|Narino|Norte de Santander|Putumayo|Quindio|Risaralda|San Andres y Providencia|Santander|Sucre|Tolima|Valle del Cauca|Vaupes|Vichada';
    this.s_a[49] = 'Anjouan (Nzwani)|Domoni|Fomboni|Grande Comore (Njazidja)|Moheli (Mwali)|Moroni|Moutsamoudou';
    this.s_a[50] = 'Bandundu|Bas-Congo|Equateur|Kasai-Occidental|Kasai-Oriental|Katanga|Kinshasa|Maniema|Nord-Kivu|Orientale|Sud-Kivu';
    this.s_a[51] = 'Bouenza|Brazzaville|Cuvette|Kouilou|Lekoumou|Likouala|Niari|Plateaux|Pool|Sangha';
    this.s_a[52] = 'Aitutaki|Atiu|Avarua|Mangaia|Manihiki|Manuae|Mauke|Mitiaro|Nassau Island|Palmerston|Penrhyn|Pukapuka|Rakahanga|Rarotonga|Suwarrow|Takutea';
    this.s_a[53] = 'Alajuela|Cartago|Guanacaste|Heredia|Limon|Puntarenas|San Jose';
    this.s_a[54] = 'Abengourou|Abidjan|Aboisso|Adiake\'|Adzope|Agboville|Agnibilekrou|Ale\'pe\'|Bangolo|Beoumi|Biankouma|Bocanda|Bondoukou|Bongouanou|Bouafle|Bouake|Bouna|Boundiali|Dabakala|Dabon|Daloa|Danane|Daoukro|Dimbokro|Divo|Duekoue|Ferkessedougou|Gagnoa|Grand Bassam|Grand-Lahou|Guiglo|Issia|Jacqueville|Katiola|Korhogo|Lakota|Man|Mankono|Mbahiakro|Odienne|Oume|Sakassou|San-Pedro|Sassandra|Seguela|Sinfra|Soubre|Tabou|Tanda|Tiassale|Tiebissou|Tingrela|Touba|Toulepleu|Toumodi|Vavoua|Yamoussoukro|Zuenoula';
    this.s_a[55] = 'Bjelovarsko-Bilogorska Zupanija|Brodsko-Posavska Zupanija|Dubrovacko-Neretvanska Zupanija|Istarska Zupanija|Karlovacka Zupanija|Koprivnicko-Krizevacka Zupanija|Krapinsko-Zagorska Zupanija|Licko-Senjska Zupanija|Medimurska Zupanija|Osjecko-Baranjska Zupanija|Pozesko-Slavonska Zupanija|Primorsko-Goranska Zupanija|Sibensko-Kninska Zupanija|Sisacko-Moslavacka Zupanija|Splitsko-Dalmatinska Zupanija|Varazdinska Zupanija|Viroviticko-Podravska Zupanija|Vukovarsko-Srijemska Zupanija|Zadarska Zupanija|Zagreb|Zagrebacka Zupanija';
    this.s_a[56] = 'Camaguey|Ciego de Avila|Cienfuegos|Ciudad de La Habana|Granma|Guantanamo|Holguin|Isla de la Juventud|La Habana|Las Tunas|Matanzas|Pinar del Rio|Sancti Spiritus|Santiago de Cuba|Villa Clara';
    this.s_a[57] = 'Famagusta|Kyrenia|Larnaca|Limassol|Nicosia|Paphos';
    this.s_a[58] = 'Brnensky|Budejovicky|Jihlavsky|Karlovarsky|Kralovehradecky|Liberecky|Olomoucky|Ostravsky|Pardubicky|Plzensky|Praha|Stredocesky|Ustecky|Zlinsky';
    this.s_a[59] = 'Arhus|Bornholm|Fredericksberg|Frederiksborg|Fyn|Kobenhavn|Kobenhavns|Nordjylland|Ribe|Ringkobing|Roskilde|Sonderjylland|Storstrom|Vejle|Vestsjalland|Viborg';
    this.s_a[60] = '\'Ali Sabih|Dikhil|Djibouti|Obock|Tadjoura';
    this.s_a[61] = 'Saint Andrew|Saint David|Saint George|Saint John|Saint Joseph|Saint Luke|Saint Mark|Saint Patrick|Saint Paul|Saint Peter';
    this.s_a[62] = 'Azua|Baoruco|Barahona|Dajabon|Distrito Nacional|Duarte|El Seibo|Elias Pina|Espaillat|Hato Mayor|Independencia|La Altagracia|La Romana|La Vega|Maria Trinidad Sanchez|Monsenor Nouel|Monte Cristi|Monte Plata|Pedernales|Peravia|Puerto Plata|Salcedo|Samana|San Cristobal|San Juan|San Pedro de Macoris|Sanchez Ramirez|Santiago|Santiago Rodriguez|Valverde';
    this.s_a[63] = 'Azuay|Bolivar|Canar|Carchi|Chimborazo|Cotopaxi|El Oro|Esmeraldas|Galapagos|Guayas|Imbabura|Loja|Los Rios|Manabi|Morona-Santiago|Napo|Orellana|Pastaza|Pichincha|Sucumbios|Tungurahua|Zamora-Chinchipe';
    this.s_a[64] = 'Ad Daqahliyah|Al Bahr al Ahmar|Al Buhayrah|Al Fayyum|Al Gharbiyah|Al Iskandariyah|Al Isma\'iliyah|Al Jizah|Al Minufiyah|Al Minya|Al Qahirah|Al Qalyubiyah|Al Wadi al Jadid|As Suways|Ash Sharqiyah|Aswan|Asyut|Bani Suwayf|Bur Sa\'id|Dumyat|Janub Sina\'|Kafr ash Shaykh|Matruh|Qina|Shamal Sina\'|Suhaj';
    this.s_a[65] = 'Ahuachapan|Cabanas|Chalatenango|Cuscatlan|La Libertad|La Paz|La Union|Morazan|San Miguel|San Salvador|San Vicente|Santa Ana|Sonsonate|Usulutan';
    this.s_a[66] = 'Annobon|Bioko Norte|Bioko Sur|Centro Sur|Kie-Ntem|Litoral|Wele-Nzas';
    this.s_a[67] = 'Akale Guzay|Barka|Denkel|Hamasen|Sahil|Semhar|Senhit|Seraye';
    this.s_a[68] = 'Harjumaa (Tallinn)|Hiiumaa (Kardla)|Ida-Virumaa (Johvi)|Jarvamaa (Paide)|Jogevamaa (Jogeva)|Laane-Virumaa (Rakvere)|Laanemaa (Haapsalu)|Parnumaa (Parnu)|Polvamaa (Polva)|Raplamaa (Rapla)|Saaremaa (Kuessaare)|Tartumaa (Tartu)|Valgamaa (Valga)|Viljandimaa (Viljandi)|Vorumaa (Voru)'
    this.s_a[69] = 'Adis Abeba (Addis Ababa)|Afar|Amara|Dire Dawa|Gambela Hizboch|Hareri Hizb|Oromiya|Sumale|Tigray|YeDebub Biheroch Bihereseboch na Hizboch';
    this.s_a[70] = 'Europa Island';
    this.s_a[71] = 'Falkland Islands (Islas Malvinas)'
    this.s_a[72] = 'Bordoy|Eysturoy|Mykines|Sandoy|Skuvoy|Streymoy|Suduroy|Tvoroyri|Vagar';
    this.s_a[73] = 'Central|Eastern|Northern|Rotuma|Western';
    this.s_a[74] = 'Aland|Etela-Suomen Laani|Ita-Suomen Laani|Lansi-Suomen Laani|Lappi|Oulun Laani';
    this.s_a[75] = 'Alsace|Aquitaine|Auvergne|Basse-Normandie|Bourgogne|Bretagne|Centre|Champagne-Ardenne|Corse|Franche-Comte|Haute-Normandie|Ile-de-France|Languedoc-Roussillon|Limousin|Lorraine|Midi-Pyrenees|Nord-Pas-de-Calais|Pays de la Loire|Picardie|Poitou-Charentes|Provence-Alpes-Cote d\'Azur|Rhone-Alpes';
    this.s_a[76] = 'French Guiana';
    this.s_a[77] = 'Archipel des Marquises|Archipel des Tuamotu|Archipel des Tubuai|Iles du Vent|Iles Sous-le-Vent';
    this.s_a[78] = 'Adelie Land|Ile Crozet|Iles Kerguelen|Iles Saint-Paul et Amsterdam';
    this.s_a[79] = 'Estuaire|Haut-Ogooue|Moyen-Ogooue|Ngounie|Nyanga|Ogooue-Ivindo|Ogooue-Lolo|Ogooue-Maritime|Woleu-Ntem';
    this.s_a[80] = 'Banjul|Central River|Lower River|North Bank|Upper River|Western';
    this.s_a[81] = 'Gaza Strip';
    this.s_a[82] = 'Abashis|Abkhazia or Ap\'khazet\'is Avtonomiuri Respublika (Sokhumi)|Adigenis|Ajaria or Acharis Avtonomiuri Respublika (Bat\'umi)|Akhalgoris|Akhalk\'alak\'is|Akhalts\'ikhis|Akhmetis|Ambrolauris|Aspindzis|Baghdat\'is|Bolnisis|Borjomis|Ch\'khorotsqus|Ch\'okhatauris|Chiat\'ura|Dedop\'listsqaros|Dmanisis|Dushet\'is|Gardabanis|Gori|Goris|Gurjaanis|Javis|K\'arelis|K\'ut\'aisi|Kaspis|Kharagaulis|Khashuris|Khobis|Khonis|Lagodekhis|Lanch\'khut\'is|Lentekhis|Marneulis|Martvilis|Mestiis|Mts\'khet\'is|Ninotsmindis|Onis|Ozurget\'is|P\'ot\'i|Qazbegis|Qvarlis|Rust\'avi|Sach\'kheris|Sagarejos|Samtrediis|Senakis|Sighnaghis|T\'bilisi|T\'elavis|T\'erjolis|T\'et\'ritsqaros|T\'ianet\'is|Tqibuli|Ts\'ageris|Tsalenjikhis|Tsalkis|Tsqaltubo|Vanis|Zestap\'onis|Zugdidi|Zugdidis';
    this.s_a[83] = 'Baden-Wuerttemberg|Bayern|Berlin|Brandenburg|Bremen|Hamburg|Hessen|Mecklenburg-Vorpommern|Niedersachsen|Nordrhein-Westfalen|Rheinland-Pfalz|Saarland|Sachsen|Sachsen-Anhalt|Schleswig-Holstein|Thueringen';
    this.s_a[84] = 'Ashanti|Brong-Ahafo|Central|Eastern|Greater Accra|Northern|Upper East|Upper West|Volta|Western';
    this.s_a[85] = 'Gibraltar';
    this.s_a[86] = 'Ile du Lys|Ile Glorieuse';
    this.s_a[87] = 'Aitolia kai Akarnania|Akhaia|Argolis|Arkadhia|Arta|Attiki|Ayion Oros (Mt. Athos)|Dhodhekanisos|Drama|Evritania|Evros|Evvoia|Florina|Fokis|Fthiotis|Grevena|Ilia|Imathia|Ioannina|Irakleion|Kardhitsa|Kastoria|Kavala|Kefallinia|Kerkyra|Khalkidhiki|Khania|Khios|Kikladhes|Kilkis|Korinthia|Kozani|Lakonia|Larisa|Lasithi|Lesvos|Levkas|Magnisia|Messinia|Pella|Pieria|Preveza|Rethimni|Rodhopi|Samos|Serrai|Thesprotia|Thessaloniki|Trikala|Voiotia|Xanthi|Zakinthos';
    this.s_a[88] = 'Avannaa (Nordgronland)|Kitaa (Vestgronland)|Tunu (Ostgronland)'
    this.s_a[89] = 'Carriacou and Petit Martinique|Saint Andrew|Saint David|Saint George|Saint John|Saint Mark|Saint Patrick';
    this.s_a[90] = 'Basse-Terre|Grande-Terre|Iles de la Petite Terre|Iles des Saintes|Marie-Galante';
    this.s_a[91] = 'Guam';
    this.s_a[92] = 'Alta Verapaz|Baja Verapaz|Chimaltenango|Chiquimula|El Progreso|Escuintla|Guatemala|Huehuetenango|Izabal|Jalapa|Jutiapa|Peten|Quetzaltenango|Quiche|Retalhuleu|Sacatepequez|San Marcos|Santa Rosa|Solola|Suchitepequez|Totonicapan|Zacapa';
    this.s_a[93] = 'Castel|Forest|St. Andrew|St. Martin|St. Peter Port|St. Pierre du Bois|St. Sampson|St. Saviour|Torteval|Vale';
    this.s_a[94] = 'Beyla|Boffa|Boke|Conakry|Coyah|Dabola|Dalaba|Dinguiraye|Dubreka|Faranah|Forecariah|Fria|Gaoual|Gueckedou|Kankan|Kerouane|Kindia|Kissidougou|Koubia|Koundara|Kouroussa|Labe|Lelouma|Lola|Macenta|Mali|Mamou|Mandiana|Nzerekore|Pita|Siguiri|Telimele|Tougue|Yomou';
    this.s_a[95] = 'Bafata|Biombo|Bissau|Bolama-Bijagos|Cacheu|Gabu|Oio|Quinara|Tombali';
    this.s_a[96] = 'Barima-Waini|Cuyuni-Mazaruni|Demerara-Mahaica|East Berbice-Corentyne|Essequibo Islands-West Demerara|Mahaica-Berbice|Pomeroon-Supenaam|Potaro-Siparuni|Upper Demerara-Berbice|Upper Takutu-Upper Essequibo';
    this.s_a[97] = 'Artibonite|Centre|Grand\'Anse|Nord|Nord-Est|Nord-Ouest|Ouest|Sud|Sud-Est';
    this.s_a[98] = 'Heard Island and McDonald Islands';
    this.s_a[99] = 'Holy See (Vatican City)'
    this.s_a[100] = 'Atlantida|Choluteca|Colon|Comayagua|Copan|Cortes|El Paraiso|Francisco Morazan|Gracias a Dios|Intibuca|Islas de la Bahia|La Paz|Lempira|Ocotepeque|Olancho|Santa Barbara|Valle|Yoro';
    this.s_a[101] = 'Hong Kong';
    this.s_a[102] = 'Howland Island';
    this.s_a[103] = 'Bacs-Kiskun|Baranya|Bekes|Bekescsaba|Borsod-Abauj-Zemplen|Budapest|Csongrad|Debrecen|Dunaujvaros|Eger|Fejer|Gyor|Gyor-Moson-Sopron|Hajdu-Bihar|Heves|Hodmezovasarhely|Jasz-Nagykun-Szolnok|Kaposvar|Kecskemet|Komarom-Esztergom|Miskolc|Nagykanizsa|Nograd|Nyiregyhaza|Pecs|Pest|Somogy|Sopron|Szabolcs-Szatmar-Bereg|Szeged|Szekesfehervar|Szolnok|Szombathely|Tatabanya|Tolna|Vas|Veszprem|Veszprem|Zala|Zalaegerszeg';
    this.s_a[104] = 'Akranes|Akureyri|Arnessysla|Austur-Bardhastrandarsysla|Austur-Hunavatnssysla|Austur-Skaftafellssysla|Borgarfjardharsysla|Dalasysla|Eyjafjardharsysla|Gullbringusysla|Hafnarfjordhur|Husavik|Isafjordhur|Keflavik|Kjosarsysla|Kopavogur|Myrasysla|Neskaupstadhur|Nordhur-Isafjardharsysla|Nordhur-Mulasys-la|Nordhur-Thingeyjarsysla|Olafsfjordhur|Rangarvallasysla|Reykjavik|Saudharkrokur|Seydhisfjordhur|Siglufjordhur|Skagafjardharsysla|Snaefellsnes-og Hnappadalssysla|Strandasysla|Sudhur-Mulasysla|Sudhur-Thingeyjarsysla|Vesttmannaeyjar|Vestur-Bardhastrandarsysla|Vestur-Hunavatnssysla|Vestur-Isafjardharsysla|Vestur-Skaftafellssysla';
    this.s_a[105] = 'Andaman and Nicobar Islands|Andhra Pradesh|Arunachal Pradesh|Assam|Bihar|Chandigarh|Chhattisgarh|Dadra and Nagar Haveli|Daman and Diu|Delhi|Goa|Gujarat|Haryana|Himachal Pradesh|Jammu and Kashmir|Jharkhand|Karnataka|Kerala|Lakshadweep|Madhya Pradesh|Maharashtra|Manipur|Meghalaya|Mizoram|Nagaland|Orissa|Pondicherry|Punjab|Rajasthan|Sikkim|Tamil Nadu|Telangana|Tripura|Uttar Pradesh|Uttaranchal|West Bengal';
    this.s_a[106] = 'Aceh|Bali|Banten|Bengkulu|East Timor|Gorontalo|Irian Jaya|Jakarta Raya|Jambi|Jawa Barat|Jawa Tengah|Jawa Timur|Kalimantan Barat|Kalimantan Selatan|Kalimantan Tengah|Kalimantan Timur|Kepulauan Bangka Belitung|Lampung|Maluku|Maluku Utara|Nusa Tenggara Barat|Nusa Tenggara Timur|Riau|Sulawesi Selatan|Sulawesi Tengah|Sulawesi Tenggara|Sulawesi Utara|Sumatera Barat|Sumatera Selatan|Sumatera Utara|Yogyakarta';
    this.s_a[107] = 'Ardabil|Azarbayjan-e Gharbi|Azarbayjan-e Sharqi|Bushehr|Chahar Mahall va Bakhtiari|Esfahan|Fars|Gilan|Golestan|Hamadan|Hormozgan|Ilam|Kerman|Kermanshah|Khorasan|Khuzestan|Kohgiluyeh va Buyer Ahmad|Kordestan|Lorestan|Markazi|Mazandaran|Qazvin|Qom|Semnan|Sistan va Baluchestan|Tehran|Yazd|Zanjan';
    this.s_a[108] = 'Al Anbar|Al Basrah|Al Muthanna|Al Qadisiyah|An Najaf|Arbil|As Sulaymaniyah|At Ta\'mim|Babil|Baghdad|Dahuk|Dhi Qar|Diyala|Karbala\'|Maysan|Ninawa|Salah ad Din|Wasit';
    this.s_a[109] = 'Carlow|Cavan|Clare|Cork|Donegal|Dublin|Galway|Kerry|Kildare|Kilkenny|Laois|Leitrim|Limerick|Longford|Louth|Mayo|Meath|Monaghan|Offaly|Roscommon|Sligo|Tipperary|Waterford|Westmeath|Wexford|Wicklow';
    this.s_a[110] = 'Antrim|Ards|Armagh|Ballymena|Ballymoney|Banbridge|Belfast|Carrickfergus|Castlereagh|Coleraine|Cookstown|Craigavon|Derry|Down|Dungannon|Fermanagh|Larne|Limavady|Lisburn|Magherafelt|Moyle|Newry and Mourne|Newtownabbey|North Down|Omagh|Strabane';
    this.s_a[111] = 'Central|Haifa|Jerusalem|Northern|Southern|Tel Aviv';
    this.s_a[112] = 'Abruzzo|Basilicata|Calabria|Campania|Emilia-Romagna|Friuli-Venezia Giulia|Lazio|Liguria|Lombardia|Marche|Molise|Piemonte|Puglia|Sardegna|Sicilia|Toscana|Trentino-Alto Adige|Umbria|Valle d\'Aosta|Veneto';
    this.s_a[113] = 'Clarendon|Hanover|Kingston|Manchester|Portland|Saint Andrew|Saint Ann|Saint Catherine|Saint Elizabeth|Saint James|Saint Mary|Saint Thomas|Trelawny|Westmoreland';
    this.s_a[114] = 'Jan Mayen';
    this.s_a[115] = 'Aichi|Akita|Aomori|Chiba|Ehime|Fukui|Fukuoka|Fukushima|Gifu|Gumma|Hiroshima|Hokkaido|Hyogo|Ibaraki|Ishikawa|Iwate|Kagawa|Kagoshima|Kanagawa|Kochi|Kumamoto|Kyoto|Mie|Miyagi|Miyazaki|Nagano|Nagasaki|Nara|Niigata|Oita|Okayama|Okinawa|Osaka|Saga|Saitama|Shiga|Shimane|Shizuoka|Tochigi|Tokushima|Tokyo|Tottori|Toyama|Wakayama|Yamagata|Yamaguchi|Yamanashi';
    this.s_a[116] = 'Jarvis Island';
    this.s_a[117] = 'Jersey';
    this.s_a[118] = 'Johnston Atoll';
    this.s_a[119] = '\'Amman|Ajlun|Al \'Aqabah|Al Balqa\'|Al Karak|Al Mafraq|At Tafilah|Az Zarqa\'|Irbid|Jarash|Ma\'an|Madaba';
    this.s_a[120] = 'Juan de Nova Island';
    this.s_a[121] = 'Almaty|Aqmola|Aqtobe|Astana|Atyrau|Batys Qazaqstan|Bayqongyr|Mangghystau|Ongtustik Qazaqstan|Pavlodar|Qaraghandy|Qostanay|Qyzylorda|Shyghys Qazaqstan|Soltustik Qazaqstan|Zhambyl';
    this.s_a[122] = 'Central|Coast|Eastern|Nairobi Area|North Eastern|Nyanza|Rift Valley|Western';
    this.s_a[123] = 'Abaiang|Abemama|Aranuka|Arorae|Banaba|Banaba|Beru|Butaritari|Central Gilberts|Gilbert Islands|Kanton|Kiritimati|Kuria|Line Islands|Line Islands|Maiana|Makin|Marakei|Nikunau|Nonouti|Northern Gilberts|Onotoa|Phoenix Islands|Southern Gilberts|Tabiteuea|Tabuaeran|Tamana|Tarawa|Tarawa|Teraina';
    this.s_a[124] = 'Chagang-do (Chagang Province)|Hamgyong-bukto (North Hamgyong Province)|Hamgyong-namdo (South Hamgyong Province)|Hwanghae-bukto (North Hwanghae Province)|Hwanghae-namdo (South Hwanghae Province)|Kaesong-si (Kaesong City)|Kangwon-do (Kangwon Province)|Namp\'o-si (Namp\'o City)|P\'yongan-bukto (North P\'yongan Province)|P\'yongan-namdo (South P\'yongan Province)|P\'yongyang-si (P\'yongyang City)|Yanggang-do (Yanggang Province)'
    this.s_a[125] = 'Ch\'ungch\'ong-bukto|Ch\'ungch\'ong-namdo|Cheju-do|Cholla-bukto|Cholla-namdo|Inch\'on-gwangyoksi|Kangwon-do|Kwangju-gwangyoksi|Kyonggi-do|Kyongsang-bukto|Kyongsang-namdo|Pusan-gwangyoksi|Soul-t\'ukpyolsi|Taegu-gwangyoksi|Taejon-gwangyoksi|Ulsan-gwangyoksi';
    this.s_a[126] = 'Al \'Asimah|Al Ahmadi|Al Farwaniyah|Al Jahra\'|Hawalli';
    this.s_a[127] = 'Batken Oblasty|Bishkek Shaary|Chuy Oblasty (Bishkek)|Jalal-Abad Oblasty|Naryn Oblasty|Osh Oblasty|Talas Oblasty|Ysyk-Kol Oblasty (Karakol)'
    this.s_a[128] = 'Attapu|Bokeo|Bolikhamxai|Champasak|Houaphan|Khammouan|Louangnamtha|Louangphabang|Oudomxai|Phongsali|Salavan|Savannakhet|Viangchan|Viangchan|Xaignabouli|Xaisomboun|Xekong|Xiangkhoang';
    this.s_a[129] = 'Aizkraukles Rajons|Aluksnes Rajons|Balvu Rajons|Bauskas Rajons|Cesu Rajons|Daugavpils|Daugavpils Rajons|Dobeles Rajons|Gulbenes Rajons|Jekabpils Rajons|Jelgava|Jelgavas Rajons|Jurmala|Kraslavas Rajons|Kuldigas Rajons|Leipaja|Liepajas Rajons|Limbazu Rajons|Ludzas Rajons|Madonas Rajons|Ogres Rajons|Preilu Rajons|Rezekne|Rezeknes Rajons|Riga|Rigas Rajons|Saldus Rajons|Talsu Rajons|Tukuma Rajons|Valkas Rajons|Valmieras Rajons|Ventspils|Ventspils Rajons';
    this.s_a[130] = 'Beyrouth|Ech Chimal|Ej Jnoub|El Bekaa|Jabal Loubnane';
    this.s_a[131] = 'Berea|Butha-Buthe|Leribe|Mafeteng|Maseru|Mohales Hoek|Mokhotlong|Qacha\'s Nek|Quthing|Thaba-Tseka';
    this.s_a[132] = 'Bomi|Bong|Grand Bassa|Grand Cape Mount|Grand Gedeh|Grand Kru|Lofa|Margibi|Maryland|Montserrado|Nimba|River Cess|Sinoe';
    this.s_a[133] = 'Ajdabiya|Al \'Aziziyah|Al Fatih|Al Jabal al Akhdar|Al Jufrah|Al Khums|Al Kufrah|An Nuqat al Khams|Ash Shati\'|Awbari|Az Zawiyah|Banghazi|Darnah|Ghadamis|Gharyan|Misratah|Murzuq|Sabha|Sawfajjin|Surt|Tarabulus|Tarhunah|Tubruq|Yafran|Zlitan';
    this.s_a[134] = 'Balzers|Eschen|Gamprin|Mauren|Planken|Ruggell|Schaan|Schellenberg|Triesen|Triesenberg|Vaduz';
    this.s_a[135] = 'Akmenes Rajonas|Alytaus Rajonas|Alytus|Anyksciu Rajonas|Birstonas|Birzu Rajonas|Druskininkai|Ignalinos Rajonas|Jonavos Rajonas|Joniskio Rajonas|Jurbarko Rajonas|Kaisiadoriu Rajonas|Kaunas|Kauno Rajonas|Kedainiu Rajonas|Kelmes Rajonas|Klaipeda|Klaipedos Rajonas|Kretingos Rajonas|Kupiskio Rajonas|Lazdiju Rajonas|Marijampole|Marijampoles Rajonas|Mazeikiu Rajonas|Moletu Rajonas|Neringa Pakruojo Rajonas|Palanga|Panevezio Rajonas|Panevezys|Pasvalio Rajonas|Plunges Rajonas|Prienu Rajonas|Radviliskio Rajonas|Raseiniu Rajonas|Rokiskio Rajonas|Sakiu Rajonas|Salcininku Rajonas|Siauliai|Siauliu Rajonas|Silales Rajonas|Silutes Rajonas|Sirvintu Rajonas|Skuodo Rajonas|Svencioniu Rajonas|Taurages Rajonas|Telsiu Rajonas|Traku Rajonas|Ukmerges Rajonas|Utenos Rajonas|Varenos Rajonas|Vilkaviskio Rajonas|Vilniaus Rajonas|Vilnius|Zarasu Rajonas';
    this.s_a[136] = 'Diekirch|Grevenmacher|Luxembourg';
    this.s_a[137] = 'Macau';
    this.s_a[138] = 'Aracinovo|Bac|Belcista|Berovo|Bistrica|Bitola|Blatec|Bogdanci|Bogomila|Bogovinje|Bosilovo|Brvenica|Cair (Skopje)|Capari|Caska|Cegrane|Centar (Skopje)|Centar Zupa|Cesinovo|Cucer-Sandevo|Debar|Delcevo|Delogozdi|Demir Hisar|Demir Kapija|Dobrusevo|Dolna Banjica|Dolneni|Dorce Petrov (Skopje)|Drugovo|Dzepciste|Gazi Baba (Skopje)|Gevgelija|Gostivar|Gradsko|Ilinden|Izvor|Jegunovce|Kamenjane|Karbinci|Karpos (Skopje)|Kavadarci|Kicevo|Kisela Voda (Skopje)|Klecevce|Kocani|Konce|Kondovo|Konopiste|Kosel|Kratovo|Kriva Palanka|Krivogastani|Krusevo|Kuklis|Kukurecani|Kumanovo|Labunista|Lipkovo|Lozovo|Lukovo|Makedonska Kamenica|Makedonski Brod|Mavrovi Anovi|Meseista|Miravci|Mogila|Murtino|Negotino|Negotino-Poloska|Novaci|Novo Selo|Oblesevo|Ohrid|Orasac|Orizari|Oslomej|Pehcevo|Petrovec|Plasnia|Podares|Prilep|Probistip|Radovis|Rankovce|Resen|Rosoman|Rostusa|Samokov|Saraj|Sipkovica|Sopiste|Sopotnika|Srbinovo|Star Dojran|Staravina|Staro Nagoricane|Stip|Struga|Strumica|Studenicani|Suto Orizari (Skopje)|Sveti Nikole|Tearce|Tetovo|Topolcani|Valandovo|Vasilevo|Veles|Velesta|Vevcani|Vinica|Vitoliste|Vranestica|Vrapciste|Vratnica|Vrutok|Zajas|Zelenikovo|Zileno|Zitose|Zletovo|Zrnovci';
    this.s_a[139] = 'Antananarivo|Antsiranana|Fianarantsoa|Mahajanga|Toamasina|Toliara';
    this.s_a[140] = 'Balaka|Blantyre|Chikwawa|Chiradzulu|Chitipa|Dedza|Dowa|Karonga|Kasungu|Likoma|Lilongwe|Machinga (Kasupe)|Mangochi|Mchinji|Mulanje|Mwanza|Mzimba|Nkhata Bay|Nkhotakota|Nsanje|Ntcheu|Ntchisi|Phalombe|Rumphi|Salima|Thyolo|Zomba';
    this.s_a[141] = 'Johor|Kedah|Kelantan|Labuan|Melaka|Negeri Sembilan|Pahang|Perak|Perlis|Pulau Pinang|Sabah|Sarawak|Selangor|Terengganu|Wilayah Persekutuan';
    this.s_a[142] = 'Alifu|Baa|Dhaalu|Faafu|Gaafu Alifu|Gaafu Dhaalu|Gnaviyani|Haa Alifu|Haa Dhaalu|Kaafu|Laamu|Lhaviyani|Maale|Meemu|Noonu|Raa|Seenu|Shaviyani|Thaa|Vaavu';
    this.s_a[143] = 'Gao|Kayes|Kidal|Koulikoro|Mopti|Segou|Sikasso|Tombouctou';
    this.s_a[144] = 'Valletta';
    this.s_a[145] = 'Man, Isle of';
    this.s_a[146] = 'Ailinginae|Ailinglaplap|Ailuk|Arno|Aur|Bikar|Bikini|Bokak|Ebon|Enewetak|Erikub|Jabat|Jaluit|Jemo|Kili|Kwajalein|Lae|Lib|Likiep|Majuro|Maloelap|Mejit|Mili|Namorik|Namu|Rongelap|Rongrik|Toke|Ujae|Ujelang|Utirik|Wotho|Wotje';
    this.s_a[147] = 'Martinique';
    this.s_a[148] = 'Adrar|Assaba|Brakna|Dakhlet Nouadhibou|Gorgol|Guidimaka|Hodh Ech Chargui|Hodh El Gharbi|Inchiri|Nouakchott|Tagant|Tiris Zemmour|Trarza';
    this.s_a[149] = 'Agalega Islands|Black River|Cargados Carajos Shoals|Flacq|Grand Port|Moka|Pamplemousses|Plaines Wilhems|Port Louis|Riviere du Rempart|Rodrigues|Savanne';
    this.s_a[150] = 'Mayotte';
    this.s_a[151] = 'Aguascalientes|Baja California|Baja California Sur|Campeche|Chiapas|Chihuahua|Coahuila de Zaragoza|Colima|Distrito Federal|Durango|Guanajuato|Guerrero|Hidalgo|Jalisco|Mexico|Michoacan de Ocampo|Morelos|Nayarit|Nuevo Leon|Oaxaca|Puebla|Queretaro de Arteaga|Quintana Roo|San Luis Potosi|Sinaloa|Sonora|Tabasco|Tamaulipas|Tlaxcala|Veracruz-Llave|Yucatan|Zacatecas';
    this.s_a[152] = 'Chuuk (Truk)|Kosrae|Pohnpei|Yap';
    this.s_a[153] = 'Midway Islands';
    this.s_a[154] = 'Balti|Cahul|Chisinau|Chisinau|Dubasari|Edinet|Gagauzia|Lapusna|Orhei|Soroca|Tighina|Ungheni';
    this.s_a[155] = 'Fontvieille|La Condamine|Monaco-Ville|Monte-Carlo';
    this.s_a[156] = 'Arhangay|Bayan-Olgiy|Bayanhongor|Bulgan|Darhan|Dornod|Dornogovi|Dundgovi|Dzavhan|Erdenet|Govi-Altay|Hentiy|Hovd|Hovsgol|Omnogovi|Ovorhangay|Selenge|Suhbaatar|Tov|Ulaanbaatar|Uvs';
    this.s_a[157] = 'Saint Anthony|Saint Georges|Saint Peter\'s';
    this.s_a[158] = 'Agadir|Al Hoceima|Azilal|Ben Slimane|Beni Mellal|Boulemane|Casablanca|Chaouen|El Jadida|El Kelaa des Srarhna|Er Rachidia|Essaouira|Fes|Figuig|Guelmim|Ifrane|Kenitra|Khemisset|Khenifra|Khouribga|Laayoune|Larache|Marrakech|Meknes|Nador|Ouarzazate|Oujda|Rabat-Sale|Safi|Settat|Sidi Kacem|Tan-Tan|Tanger|Taounate|Taroudannt|Tata|Taza|Tetouan|Tiznit';
    this.s_a[159] = 'Cabo Delgado|Gaza|Inhambane|Manica|Maputo|Nampula|Niassa|Sofala|Tete|Zambezia';
    this.s_a[160] = 'Caprivi|Erongo|Hardap|Karas|Khomas|Kunene|Ohangwena|Okavango|Omaheke|Omusati|Oshana|Oshikoto|Otjozondjupa';
    this.s_a[161] = 'Aiwo|Anabar|Anetan|Anibare|Baiti|Boe|Buada|Denigomodu|Ewa|Ijuw|Meneng|Nibok|Uaboe|Yaren';
    this.s_a[162] = 'Bagmati|Bheri|Dhawalagiri|Gandaki|Janakpur|Karnali|Kosi|Lumbini|Mahakali|Mechi|Narayani|Rapti|Sagarmatha|Seti';
    this.s_a[163] = 'Drenthe|Flevoland|Friesland|Gelderland|Groningen|Limburg|Noord-Brabant|Noord-Holland|Overijssel|Utrecht|Zeeland|Zuid-Holland';
    this.s_a[164] = 'Netherlands Antilles';
    this.s_a[165] = 'Iles Loyaute|Nord|Sud';
    this.s_a[166] = 'Akaroa|Amuri|Ashburton|Bay of Islands|Bruce|Buller|Chatham Islands|Cheviot|Clifton|Clutha|Cook|Dannevirke|Egmont|Eketahuna|Ellesmere|Eltham|Eyre|Featherston|Franklin|Golden Bay|Great Barrier Island|Grey|Hauraki Plains|Hawera|Hawke\'s Bay|Heathcote|Hikurangi|Hobson|Hokianga|Horowhenua|Hurunui|Hutt|Inangahua|Inglewood|Kaikoura|Kairanga|Kiwitea|Lake|Mackenzie|Malvern|Manaia|Manawatu|Mangonui|Maniototo|Marlborough|Masterton|Matamata|Mount Herbert|Ohinemuri|Opotiki|Oroua|Otamatea|Otorohanga|Oxford|Pahiatua|Paparua|Patea|Piako|Pohangina|Raglan|Rangiora|Rangitikei|Rodney|Rotorua|Runanga|Saint Kilda|Silverpeaks|Southland|Stewart Island|Stratford|Strathallan|Taranaki|Taumarunui|Taupo|Tauranga|Thames-Coromandel|Tuapeka|Vincent|Waiapu|Waiheke|Waihemo|Waikato|Waikohu|Waimairi|Waimarino|Waimate|Waimate West|Waimea|Waipa|Waipawa|Waipukurau|Wairarapa South|Wairewa|Wairoa|Waitaki|Waitomo|Waitotara|Wallace|Wanganui|Waverley|Westland|Whakatane|Whangarei|Whangaroa|Woodville';
    this.s_a[167] = 'Atlantico Norte|Atlantico Sur|Boaco|Carazo|Chinandega|Chontales|Esteli|Granada|Jinotega|Leon|Madriz|Managua|Masaya|Matagalpa|Nueva Segovia|Rio San Juan|Rivas';
    this.s_a[168] = 'Agadez|Diffa|Dosso|Maradi|Niamey|Tahoua|Tillaberi|Zinder';
    this.s_a[169] = 'Abia|Abuja Federal Capital Territory|Adamawa|Akwa Ibom|Anambra|Bauchi|Bayelsa|Benue|Borno|Cross River|Delta|Ebonyi|Edo|Ekiti|Enugu|Gombe|Imo|Jigawa|Kaduna|Kano|Katsina|Kebbi|Kogi|Kwara|Lagos|Nassarawa|Niger|Ogun|Ondo|Osun|Oyo|Plateau|Rivers|Sokoto|Taraba|Yobe|Zamfara';
    this.s_a[170] = 'Niue';
    this.s_a[171] = 'Norfolk Island';
    this.s_a[172] = 'Northern Islands|Rota|Saipan|Tinian';
    this.s_a[173] = 'Akershus|Aust-Agder|Buskerud|Finnmark|Hedmark|Hordaland|More og Romsdal|Nord-Trondelag|Nordland|Oppland|Oslo|Ostfold|Rogaland|Sogn og Fjordane|Sor-Trondelag|Telemark|Troms|Vest-Agder|Vestfold';
    this.s_a[174] = 'Ad Dakhiliyah|Al Batinah|Al Wusta|Ash Sharqiyah|Az Zahirah|Masqat|Musandam|Zufar';
    this.s_a[175] = 'Balochistan|Federally Administered Tribal Areas|Islamabad Capital Territory|North-West Frontier Province|Punjab|Sindh';
    this.s_a[176] = 'Aimeliik|Airai|Angaur|Hatobohei|Kayangel|Koror|Melekeok|Ngaraard|Ngarchelong|Ngardmau|Ngatpang|Ngchesar|Ngeremlengui|Ngiwal|Palau Island|Peleliu|Sonsoral|Tobi';
    this.s_a[177] = 'Bocas del Toro|Chiriqui|Cocle|Colon|Darien|Herrera|Los Santos|Panama|San Blas|Veraguas';
    this.s_a[178] = 'Bougainville|Central|Chimbu|East New Britain|East Sepik|Eastern Highlands|Enga|Gulf|Madang|Manus|Milne Bay|Morobe|National Capital|New Ireland|Northern|Sandaun|Southern Highlands|West New Britain|Western|Western Highlands';
    this.s_a[179] = 'Alto Paraguay|Alto Parana|Amambay|Asuncion (city)|Boqueron|Caaguazu|Caazapa|Canindeyu|Central|Concepcion|Cordillera|Guaira|Itapua|Misiones|Neembucu|Paraguari|Presidente Hayes|San Pedro';
    this.s_a[180] = 'Amazonas|Ancash|Apurimac|Arequipa|Ayacucho|Cajamarca|Callao|Cusco|Huancavelica|Huanuco|Ica|Junin|La Libertad|Lambayeque|Lima|Loreto|Madre de Dios|Moquegua|Pasco|Piura|Puno|San Martin|Tacna|Tumbes|Ucayali';
    this.s_a[181] = 'Abra|Agusan del Norte|Agusan del Sur|Aklan|Albay|Angeles|Antique|Aurora|Bacolod|Bago|Baguio|Bais|Basilan|Basilan City|Bataan|Batanes|Batangas|Batangas City|Benguet|Bohol|Bukidnon|Bulacan|Butuan|Cabanatuan|Cadiz|Cagayan|Cagayan de Oro|Calbayog|Caloocan|Camarines Norte|Camarines Sur|Camiguin|Canlaon|Capiz|Catanduanes|Cavite|Cavite City|Cebu|Cebu City|Cotabato|Dagupan|Danao|Dapitan|Davao City Davao|Davao del Sur|Davao Oriental|Dipolog|Dumaguete|Eastern Samar|General Santos|Gingoog|Ifugao|Iligan|Ilocos Norte|Ilocos Sur|Iloilo|Iloilo City|Iriga|Isabela|Kalinga-Apayao|La Carlota|La Union|Laguna|Lanao del Norte|Lanao del Sur|Laoag|Lapu-Lapu|Legaspi|Leyte|Lipa|Lucena|Maguindanao|Mandaue|Manila|Marawi|Marinduque|Masbate|Mindoro Occidental|Mindoro Oriental|Misamis Occidental|Misamis Oriental|Mountain|Naga|Negros Occidental|Negros Oriental|North Cotabato|Northern Samar|Nueva Ecija|Nueva Vizcaya|Olongapo|Ormoc|Oroquieta|Ozamis|Pagadian|Palawan|Palayan|Pampanga|Pangasinan|Pasay|Puerto Princesa|Quezon|Quezon City|Quirino|Rizal|Romblon|Roxas|Samar|San Carlos (in Negros Occidental)|San Carlos (in Pangasinan)|San Jose|San Pablo|Silay|Siquijor|Sorsogon|South Cotabato|Southern Leyte|Sultan Kudarat|Sulu|Surigao|Surigao del Norte|Surigao del Sur|Tacloban|Tagaytay|Tagbilaran|Tangub|Tarlac|Tawitawi|Toledo|Trece Martires|Zambales|Zamboanga|Zamboanga del Norte|Zamboanga del Sur';
    this.s_a[182] = 'Pitcaim Islands';
    this.s_a[183] = 'Dolnoslaskie|Kujawsko-Pomorskie|Lodzkie|Lubelskie|Lubuskie|Malopolskie|Mazowieckie|Opolskie|Podkarpackie|Podlaskie|Pomorskie|Slaskie|Swietokrzyskie|Warminsko-Mazurskie|Wielkopolskie|Zachodniopomorskie';
    this.s_a[184] = 'Acores (Azores)|Aveiro|Beja|Braga|Braganca|Castelo Branco|Coimbra|Evora|Faro|Guarda|Leiria|Lisboa|Madeira|Portalegre|Porto|Santarem|Setubal|Viana do Castelo|Vila Real|Viseu';
    this.s_a[185] = 'Adjuntas|Aguada|Aguadilla|Aguas Buenas|Aibonito|Anasco|Arecibo|Arroyo|Barceloneta|Barranquitas|Bayamon|Cabo Rojo|Caguas|Camuy|Canovanas|Carolina|Catano|Cayey|Ceiba|Ciales|Cidra|Coamo|Comerio|Corozal|Culebra|Dorado|Fajardo|Florida|Guanica|Guayama|Guayanilla|Guaynabo|Gurabo|Hatillo|Hormigueros|Humacao|Isabela|Jayuya|Juana Diaz|Juncos|Lajas|Lares|Las Marias|Las Piedras|Loiza|Luquillo|Manati|Maricao|Maunabo|Mayaguez|Moca|Morovis|Naguabo|Naranjito|Orocovis|Patillas|Penuelas|Ponce|Quebradillas|Rincon|Rio Grande|Sabana Grande|Salinas|San German|San Juan|San Lorenzo|San Sebastian|Santa Isabel|Toa Alta|Toa Baja|Trujillo Alto|Utuado|Vega Alta|Vega Baja|Vieques|Villalba|Yabucoa|Yauco';
    this.s_a[186] = 'Ad Dawhah|Al Ghuwayriyah|Al Jumayliyah|Al Khawr|Al Wakrah|Ar Rayyan|Jarayan al Batinah|Madinat ash Shamal|Umm Salal';
    this.s_a[187] = 'Reunion';
    this.s_a[188] = 'Alba|Arad|Arges|Bacau|Bihor|Bistrita-Nasaud|Botosani|Braila|Brasov|Bucuresti|Buzau|Calarasi|Caras-Severin|Cluj|Constanta|Covasna|Dimbovita|Dolj|Galati|Giurgiu|Gorj|Harghita|Hunedoara|Ialomita|Iasi|Maramures|Mehedinti|Mures|Neamt|Olt|Prahova|Salaj|Satu Mare|Sibiu|Suceava|Teleorman|Timis|Tulcea|Vaslui|Vilcea|Vrancea';
    this.s_a[189] = 'Adygeya (Maykop)|Aginskiy Buryatskiy (Aginskoye)|Altay (Gorno-Altaysk)|Altayskiy (Barnaul)|Amurskaya (Blagoveshchensk)|Arkhangel\'skaya|Astrakhanskaya|Bashkortostan (Ufa)|Belgorodskaya|Bryanskaya|Buryatiya (Ulan-Ude)|Chechnya (Groznyy)|Chelyabinskaya|Chitinskaya|Chukotskiy (Anadyr\')|Chuvashiya (Cheboksary)|Dagestan (Makhachkala)|Evenkiyskiy (Tura)|Ingushetiya (Nazran\')|Irkutskaya|Ivanovskaya|Kabardino-Balkariya (Nal\'chik)|Kaliningradskaya|Kalmykiya (Elista)|Kaluzhskaya|Kamchatskaya (Petropavlovsk-Kamchatskiy)|Karachayevo-Cherkesiya (Cherkessk)|Kareliya (Petrozavodsk)|Kemerovskaya|Khabarovskiy|Khakasiya (Abakan)|Khanty-Mansiyskiy (Khanty-Mansiysk)|Kirovskaya|Komi (Syktyvkar)|Komi-Permyatskiy (Kudymkar)|Koryakskiy (Palana)|Kostromskaya|Krasnodarskiy|Krasnoyarskiy|Kurganskaya|Kurskaya|Leningradskaya|Lipetskaya|Magadanskaya|Mariy-El (Yoshkar-Ola)|Mordoviya (Saransk)|Moskovskaya|Moskva (Moscow)|Murmanskaya|Nenetskiy (Nar\'yan-Mar)|Nizhegorodskaya|Novgorodskaya|Novosibirskaya|Omskaya|Orenburgskaya|Orlovskaya (Orel)|Penzenskaya|Permskaya|Primorskiy (Vladivostok)|Pskovskaya|Rostovskaya|Ryazanskaya|Sakha (Yakutsk)|Sakhalinskaya (Yuzhno-Sakhalinsk)|Samarskaya|Sankt-Peterburg (Saint Petersburg)|Saratovskaya|Severnaya Osetiya-Alaniya [North Ossetia] (Vladikavkaz)|Smolenskaya|Stavropol\'skiy|Sverdlovskaya (Yekaterinburg)|Tambovskaya|Tatarstan (Kazan\')|Taymyrskiy (Dudinka)|Tomskaya|Tul\'skaya|Tverskaya|Tyumenskaya|Tyva (Kyzyl)|Udmurtiya (Izhevsk)|Ul\'yanovskaya|Ust\'-Ordynskiy Buryatskiy (Ust\'-Ordynskiy)|Vladimirskaya|Volgogradskaya|Vologodskaya|Voronezhskaya|Yamalo-Nenetskiy (Salekhard)|Yaroslavskaya|Yevreyskaya';
    this.s_a[190] = 'Butare|Byumba|Cyangugu|Gikongoro|Gisenyi|Gitarama|Kibungo|Kibuye|Kigali Rurale|Kigali-ville|Ruhengeri|Umutara';
    this.s_a[191] = 'Ascension|Saint Helena|Tristan da Cunha';
    this.s_a[192] = 'Christ Church Nichola Town|Saint Anne Sandy Point|Saint George Basseterre|Saint George Gingerland|Saint James Windward|Saint John Capisterre|Saint John Figtree|Saint Mary Cayon|Saint Paul Capisterre|Saint Paul Charlestown|Saint Peter Basseterre|Saint Thomas Lowland|Saint Thomas Middle Island|Trinity Palmetto Point';
    this.s_a[193] = 'Anse-la-Raye|Castries|Choiseul|Dauphin|Dennery|Gros Islet|Laborie|Micoud|Praslin|Soufriere|Vieux Fort';
    this.s_a[194] = 'Miquelon|Saint Pierre';
    this.s_a[195] = 'Charlotte|Grenadines|Saint Andrew|Saint David|Saint George|Saint Patrick';
    this.s_a[196] = 'A\'ana|Aiga-i-le-Tai|Atua|Fa\'asaleleaga|Gaga\'emauga|Gagaifomauga|Palauli|Satupa\'itea|Tuamasaga|Va\'a-o-Fonoti|Vaisigano';
    this.s_a[197] = 'Acquaviva|Borgo Maggiore|Chiesanuova|Domagnano|Faetano|Fiorentino|Monte Giardino|San Marino|Serravalle';
    this.s_a[198] = 'Principe|Sao Tome';
    this.s_a[199] = '\'Asir|Al Bahah|Al Hudud ash Shamaliyah|Al Jawf|Al Madinah|Al Qasim|Ar Riyad|Ash Sharqiyah (Eastern Province)|Ha\'il|Jizan|Makkah|Najran|Tabuk';
    this.s_a[200] = 'Aberdeen City|Aberdeenshire|Angus|Argyll and Bute|City of Edinburgh|Clackmannanshire|Dumfries and Galloway|Dundee City|East Ayrshire|East Dunbartonshire|East Lothian|East Renfrewshire|Eilean Siar (Western Isles)|Falkirk|Fife|Glasgow City|Highland|Inverclyde|Midlothian|Moray|North Ayrshire|North Lanarkshire|Orkney Islands|Perth and Kinross|Renfrewshire|Shetland Islands|South Ayrshire|South Lanarkshire|Stirling|The Scottish Borders|West Dunbartonshire|West Lothian';
    this.s_a[201] = 'Dakar|Diourbel|Fatick|Kaolack|Kolda|Louga|Saint-Louis|Tambacounda|Thies|Ziguinchor';
    this.s_a[202] = 'Anse aux Pins|Anse Boileau|Anse Etoile|Anse Louis|Anse Royale|Baie Lazare|Baie Sainte Anne|Beau Vallon|Bel Air|Bel Ombre|Cascade|Glacis|Grand\' Anse (on Mahe)|Grand\' Anse (on Praslin)|La Digue|La Riviere Anglaise|Mont Buxton|Mont Fleuri|Plaisance|Pointe La Rue|Port Glaud|Saint Louis|Takamaka';
    this.s_a[203] = 'Eastern|Northern|Southern|Western';
    this.s_a[204] = 'Singapore';
    this.s_a[205] = 'Banskobystricky|Bratislavsky|Kosicky|Nitriansky|Presovsky|Trenciansky|Trnavsky|Zilinsky';
    this.s_a[206] = 'Ajdovscina|Beltinci|Bled|Bohinj|Borovnica|Bovec|Brda|Brezice|Brezovica|Cankova-Tisina|Celje|Cerklje na Gorenjskem|Cerknica|Cerkno|Crensovci|Crna na Koroskem|Crnomelj|Destrnik-Trnovska Vas|Divaca|Dobrepolje|Dobrova-Horjul-Polhov Gradec|Dol pri Ljubljani|Domzale|Dornava|Dravograd|Duplek|Gorenja Vas-Poljane|Gorisnica|Gornja Radgona|Gornji Grad|Gornji Petrovci|Grosuplje|Hodos Salovci|Hrastnik|Hrpelje-Kozina|Idrija|Ig|Ilirska Bistrica|Ivancna Gorica|Izola|Jesenice|Jursinci|Kamnik|Kanal|Kidricevo|Kobarid|Kobilje|Kocevje|Komen|Koper|Kozje|Kranj|Kranjska Gora|Krsko|Kungota|Kuzma|Lasko|Lenart|Lendava|Litija|Ljubljana|Ljubno|Ljutomer|Logatec|Loska Dolina|Loski Potok|Luce|Lukovica|Majsperk|Maribor|Medvode|Menges|Metlika|Mezica|Miren-Kostanjevica|Mislinja|Moravce|Moravske Toplice|Mozirje|Murska Sobota|Muta|Naklo|Nazarje|Nova Gorica|Novo Mesto|Odranci|Ormoz|Osilnica|Pesnica|Piran|Pivka|Podcetrtek|Podvelka-Ribnica|Postojna|Preddvor|Ptuj|Puconci|Race-Fram|Radece|Radenci|Radlje ob Dravi|Radovljica|Ravne-Prevalje|Ribnica|Rogasevci|Rogaska Slatina|Rogatec|Ruse|Semic|Sencur|Sentilj|Sentjernej|Sentjur pri Celju|Sevnica|Sezana|Skocjan|Skofja Loka|Skofljica|Slovenj Gradec|Slovenska Bistrica|Slovenske Konjice|Smarje pri Jelsah|Smartno ob Paki|Sostanj|Starse|Store|Sveti Jurij|Tolmin|Trbovlje|Trebnje|Trzic|Turnisce|Velenje|Velike Lasce|Videm|Vipava|Vitanje|Vodice|Vojnik|Vrhnika|Vuzenica|Zagorje ob Savi|Zalec|Zavrc|Zelezniki|Ziri|Zrece';
    this.s_a[207] = 'Bellona|Central|Choiseul (Lauru)|Guadalcanal|Honiara|Isabel|Makira|Malaita|Rennell|Temotu|Western';
    this.s_a[208] = 'Awdal|Bakool|Banaadir|Bari|Bay|Galguduud|Gedo|Hiiraan|Jubbada Dhexe|Jubbada Hoose|Mudug|Nugaal|Sanaag|Shabeellaha Dhexe|Shabeellaha Hoose|Sool|Togdheer|Woqooyi Galbeed';
    this.s_a[209] = 'Eastern Cape|Free State|Gauteng|KwaZulu-Natal|Mpumalanga|North-West|Northern Cape|Northern Province|Western Cape';
    this.s_a[210] = 'Bird Island|Bristol Island|Clerke Rocks|Montagu Island|Saunders Island|South Georgia|Southern Thule|Traversay Islands';
    this.s_a[211] = 'Andalucia|Aragon|Asturias|Baleares (Balearic Islands)|Canarias (Canary Islands)|Cantabria|Castilla y Leon|Castilla-La Mancha|Cataluna|Ceuta|Communidad Valencian|Extremadura|Galicia|Islas Chafarinas|La Rioja|Madrid|Melilla|Murcia|Navarra|Pais Vasco (Basque Country)|Penon de Alhucemas|Penon de Velez de la Gomera';
    this.s_a[212] = 'Spratly Islands';
    this.s_a[213] = 'Central|Eastern|North Central|North Eastern|North Western|Northern|Sabaragamuwa|Southern|Uva|Western';
    this.s_a[214] = 'A\'ali an Nil|Al Bahr al Ahmar|Al Buhayrat|Al Jazirah|Al Khartum|Al Qadarif|Al Wahdah|An Nil al Abyad|An Nil al Azraq|Ash Shamaliyah|Bahr al Jabal|Gharb al Istiwa\'iyah|Gharb Bahr al Ghazal|Gharb Darfur|Gharb Kurdufan|Janub Darfur|Janub Kurdufan|Junqali|Kassala|Nahr an Nil|Shamal Bahr al Ghazal|Shamal Darfur|Shamal Kurdufan|Sharq al Istiwa\'iyah|Sinnar|Warab';
    this.s_a[215] = 'Brokopondo|Commewijne|Coronie|Marowijne|Nickerie|Para|Paramaribo|Saramacca|Sipaliwini|Wanica';
    this.s_a[216] = 'Barentsoya|Bjornoya|Edgeoya|Hopen|Kvitoya|Nordaustandet|Prins Karls Forland|Spitsbergen';
    this.s_a[217] = 'Hhohho|Lubombo|Manzini|Shiselweni';
    this.s_a[218] = 'Blekinge|Dalarnas|Gavleborgs|Gotlands|Hallands|Jamtlands|Jonkopings|Kalmar|Kronobergs|Norrbottens|Orebro|Ostergotlands|Skane|Sodermanlands|Stockholms|Uppsala|Varmlands|Vasterbottens|Vasternorrlands|Vastmanlands|Vastra Gotalands';
    this.s_a[219] = 'Aargau|Ausser-Rhoden|Basel-Landschaft|Basel-Stadt|Bern|Fribourg|Geneve|Glarus|Graubunden|Inner-Rhoden|Jura|Luzern|Neuchatel|Nidwalden|Obwalden|Sankt Gallen|Schaffhausen|Schwyz|Solothurn|Thurgau|Ticino|Uri|Valais|Vaud|Zug|Zurich';
    this.s_a[220] = 'Al Hasakah|Al Ladhiqiyah|Al Qunaytirah|Ar Raqqah|As Suwayda\'|Dar\'a|Dayr az Zawr|Dimashq|Halab|Hamah|Hims|Idlib|Rif Dimashq|Tartus';
    this.s_a[221] = 'Chang-hua|Chi-lung|Chia-i|Chia-i|Chung-hsing-hsin-ts\'un|Hsin-chu|Hsin-chu|Hua-lien|I-lan|Kao-hsiung|Kao-hsiung|Miao-li|Nan-t\'ou|P\'eng-hu|P\'ing-tung|T\'ai-chung|T\'ai-chung|T\'ai-nan|T\'ai-nan|T\'ai-pei|T\'ai-pei|T\'ai-tung|T\'ao-yuan|Yun-lin';
    this.s_a[222] = 'Viloyati Khatlon|Viloyati Leninobod|Viloyati Mukhtori Kuhistoni Badakhshon';
    this.s_a[223] = 'Arusha|Dar es Salaam|Dodoma|Iringa|Kagera|Kigoma|Kilimanjaro|Lindi|Mara|Mbeya|Morogoro|Mtwara|Mwanza|Pemba North|Pemba South|Pwani|Rukwa|Ruvuma|Shinyanga|Singida|Tabora|Tanga|Zanzibar Central/South|Zanzibar North|Zanzibar Urban/West';
    this.s_a[224] = 'Amnat Charoen|Ang Thong|Buriram|Chachoengsao|Chai Nat|Chaiyaphum|Chanthaburi|Chiang Mai|Chiang Rai|Chon Buri|Chumphon|Kalasin|Kamphaeng Phet|Kanchanaburi|Khon Kaen|Krabi|Krung Thep Mahanakhon (Bangkok)|Lampang|Lamphun|Loei|Lop Buri|Mae Hong Son|Maha Sarakham|Mukdahan|Nakhon Nayok|Nakhon Pathom|Nakhon Phanom|Nakhon Ratchasima|Nakhon Sawan|Nakhon Si Thammarat|Nan|Narathiwat|Nong Bua Lamphu|Nong Khai|Nonthaburi|Pathum Thani|Pattani|Phangnga|Phatthalung|Phayao|Phetchabun|Phetchaburi|Phichit|Phitsanulok|Phra Nakhon Si Ayutthaya|Phrae|Phuket|Prachin Buri|Prachuap Khiri Khan|Ranong|Ratchaburi|Rayong|Roi Et|Sa Kaeo|Sakon Nakhon|Samut Prakan|Samut Sakhon|Samut Songkhram|Sara Buri|Satun|Sing Buri|Sisaket|Songkhla|Sukhothai|Suphan Buri|Surat Thani|Surin|Tak|Trang|Trat|Ubon Ratchathani|Udon Thani|Uthai Thani|Uttaradit|Yala|Yasothon';
    this.s_a[225] = 'Tobago';
    this.s_a[226] = 'De La Kara|Des Plateaux|Des Savanes|Du Centre|Maritime';
    this.s_a[227] = 'Atafu|Fakaofo|Nukunonu';
    this.s_a[228] = 'Ha\'apai|Tongatapu|Vava\'u';
    this.s_a[229] = 'Arima|Caroni|Mayaro|Nariva|Port-of-Spain|Saint Andrew|Saint David|Saint George|Saint Patrick|San Fernando|Victoria';
    this.s_a[230] = 'Ariana|Beja|Ben Arous|Bizerte|El Kef|Gabes|Gafsa|Jendouba|Kairouan|Kasserine|Kebili|Mahdia|Medenine|Monastir|Nabeul|Sfax|Sidi Bou Zid|Siguests|Sousse|Tataouine|Tozeur|Tunis|Zaghouan';
    this.s_a[231] = 'Adana|Adiyaman|Afyon|Agri|Aksaray|Amasya|Ankara|Antalya|Ardahan|Artvin|Aydin|Balikesir|Bartin|Batman|Bayburt|Bilecik|Bingol|Bitlis|Bolu|Burdur|Bursa|Canakkale|Cankiri|Corum|Denizli|Diyarbakir|Duzce|Edirne|Elazig|Erzincan|Erzurum|Eskisehir|Gaziantep|Giresun|Gumushane|Hakkari|Hatay|Icel|Igdir|Isparta|Istanbul|Izmir|Kahramanmaras|Karabuk|Karaman|Kars|Kastamonu|Kayseri|Kilis|Kirikkale|Kirklareli|Kirsehir|Kocaeli|Konya|Kutahya|Malatya|Manisa|Mardin|Mugla|Mus|Nevsehir|Nigde|Ordu|Osmaniye|Rize|Sakarya|Samsun|Sanliurfa|Siirt|Sinop|Sirnak|Sivas|Tekirdag|Tokat|Trabzon|Tunceli|Usak|Van|Yalova|Yozgat|Zonguldak';
    this.s_a[232] = 'Ahal Welayaty|Balkan Welayaty|Dashhowuz Welayaty|Lebap Welayaty|Mary Welayaty';
    this.s_a[233] = 'Tuvalu';
    this.s_a[234] = 'Adjumani|Apac|Arua|Bugiri|Bundibugyo|Bushenyi|Busia|Gulu|Hoima|Iganga|Jinja|Kabale|Kabarole|Kalangala|Kampala|Kamuli|Kapchorwa|Kasese|Katakwi|Kibale|Kiboga|Kisoro|Kitgum|Kotido|Kumi|Lira|Luwero|Masaka|Masindi|Mbale|Mbarara|Moroto|Moyo|Mpigi|Mubende|Mukono|Nakasongola|Nebbi|Ntungamo|Pallisa|Rakai|Rukungiri|Sembabule|Soroti|Tororo';
    this.s_a[235] = 'Avtonomna Respublika Krym (Simferopol\')|Cherkas\'ka (Cherkasy)|Chernihivs\'ka (Chernihiv)|Chernivets\'ka (Chernivtsi)|Dnipropetrovs\'ka (Dnipropetrovs\'k)|Donets\'ka (Donets\'k)|Ivano-Frankivs\'ka (Ivano-Frankivs\'k)|Kharkivs\'ka (Kharkiv)|Khersons\'ka (Kherson)|Khmel\'nyts\'ka (Khmel\'nyts\'kyy)|Kirovohrads\'ka (Kirovohrad)|Kyyiv|Kyyivs\'ka (Kiev)|L\'vivs\'ka (L\'viv)|Luhans\'ka (Luhans\'k)|Mykolayivs\'ka (Mykolayiv)|Odes\'ka (Odesa)|Poltavs\'ka (Poltava)|Rivnens\'ka (Rivne)|Sevastopol\'|Sums\'ka (Sumy)|Ternopil\'s\'ka (Ternopil\')|Vinnyts\'ka (Vinnytsya)|Volyns\'ka (Luts\'k)|Zakarpats\'ka (Uzhhorod)|Zaporiz\'ka (Zaporizhzhya)|Zhytomyrs\'ka (Zhytomyr)'
    this.s_a[236] = '\'Ajman|Abu Zaby (Abu Dhabi)|Al Fujayrah|Ash Shariqah (Sharjah)|Dubayy (Dubai)|Ra\'s al Khaymah|Umm al Qaywayn';
    this.s_a[237] = 'Barking and Dagenham|Barnet|Barnsley|Bath and North East Somerset|Bedfordshire|Bexley|Birmingham|Blackburn with Darwen|Blackpool|Bolton|Bournemouth|Bracknell Forest|Bradford|Brent|Brighton and Hove|Bromley|Buckinghamshire|Bury|Calderdale|Cambridgeshire|Camden|Cheshire|City of Bristol|City of Kingston upon Hull|City of London|Cornwall|Coventry|Croydon|Cumbria|Darlington|Derby|Derbyshire|Devon|Doncaster|Dorset|Dudley|Durham|Ealing|East Riding of Yorkshire|East Sussex|Enfield|Essex|Gateshead|Gloucestershire|Greenwich|Hackney|Halton|Hammersmith and Fulham|Hampshire|Haringey|Harrow|Hartlepool|Havering|Herefordshire|Hertfordshire|Hillingdon|Hounslow|Isle of Wight|Islington|Kensington and Chelsea|Kent|Kingston upon Thames|Kirklees|Knowsley|Lambeth|Lancashire|Leeds|Leicester|Leicestershire|Lewisham|Lincolnshire|Liverpool|Luton|Manchester|Medway|Merton|Middlesbrough|Milton Keynes|Newcastle upon Tyne|Newham|Norfolk|North East Lincolnshire|North Lincolnshire|North Somerset|North Tyneside|North Yorkshire|Northamptonshire|Northumberland|Nottingham|Nottinghamshire|Oldham|Oxfordshire|Peterborough|Plymouth|Poole|Portsmouth|Reading|Redbridge|Redcar and Cleveland|Richmond upon Thames|Rochdale|Rotherham|Rutland|Salford|Sandwell|Sefton|Sheffield|Shropshire|Slough|Solihull|Somerset|South Gloucestershire|South Tyneside|Southampton|Southend-on-Sea|Southwark|St. Helens|Staffordshire|Stockport|Stockton-on-Tees|Stoke-on-Trent|Suffolk|Sunderland|Surrey|Sutton|Swindon|Tameside|Telford and Wrekin|Thurrock|Torbay|Tower Hamlets|Trafford|Wakefield|Walsall|Waltham Forest|Wandsworth|Warrington|Warwickshire|West Berkshire|West Sussex|Westminster|Wigan|Wiltshire|Windsor and Maidenhead|Wirral|Wokingham|Wolverhampton|Worcestershire|York';
    this.s_a[238] = 'Artigas|Canelones|Cerro Largo|Colonia|Durazno|Flores|Florida|Lavalleja|Maldonado|Montevideo|Paysandu|Rio Negro|Rivera|Rocha|Salto|San Jose|Soriano|Tacuarembo|Treinta y Tres';
    this.s_a[239] = 'Alabama|Alaska|Arizona|Arkansas|California|Colorado|Connecticut|Delaware|District of Columbia|Florida|Georgia|Hawaii|Idaho|Illinois|Indiana|Iowa|Kansas|Kentucky|Louisiana|Maine|Maryland|Massachusetts|Michigan|Minnesota|Mississippi|Missouri|Montana|Nebraska|Nevada|New Hampshire|New Jersey|New Mexico|New York|North Carolina|North Dakota|Ohio|Oklahoma|Oregon|Pennsylvania|Rhode Island|South Carolina|South Dakota|Tennessee|Texas|Utah|Vermont|Virginia|Washington|West Virginia|Wisconsin|Wyoming';
    this.s_a[240] = 'Andijon Wiloyati|Bukhoro Wiloyati|Farghona Wiloyati|Jizzakh Wiloyati|Khorazm Wiloyati (Urganch)|Namangan Wiloyati|Nawoiy Wiloyati|Qashqadaryo Wiloyati (Qarshi)|Qoraqalpoghiston (Nukus)|Samarqand Wiloyati|Sirdaryo Wiloyati (Guliston)|Surkhondaryo Wiloyati (Termiz)|Toshkent Shahri|Toshkent Wiloyati';
    this.s_a[241] = 'Malampa|Penama|Sanma|Shefa|Tafea|Torba';
    this.s_a[242] = 'Amazonas|Anzoategui|Apure|Aragua|Barinas|Bolivar|Carabobo|Cojedes|Delta Amacuro|Dependencias Federales|Distrito Federal|Falcon|Guarico|Lara|Merida|Miranda|Monagas|Nueva Esparta|Portuguesa|Sucre|Tachira|Trujillo|Vargas|Yaracuy|Zulia';
    this.s_a[243] = 'An Giang|Ba Ria-Vung Tau|Bac Giang|Bac Kan|Bac Lieu|Bac Ninh|Ben Tre|Binh Dinh|Binh Duong|Binh Phuoc|Binh Thuan|Ca Mau|Can Tho|Cao Bang|Da Nang|Dac Lak|Dong Nai|Dong Thap|Gia Lai|Ha Giang|Ha Nam|Ha Noi|Ha Tay|Ha Tinh|Hai Duong|Hai Phong|Ho Chi Minh|Hoa Binh|Hung Yen|Khanh Hoa|Kien Giang|Kon Tum|Lai Chau|Lam Dong|Lang Son|Lao Cai|Long An|Nam Dinh|Nghe An|Ninh Binh|Ninh Thuan|Phu Tho|Phu Yen|Quang Binh|Quang Nam|Quang Ngai|Quang Ninh|Quang Tri|Soc Trang|Son La|Tay Ninh|Thai Binh|Thai Nguyen|Thanh Hoa|Thua Thien-Hue|Tien Giang|Tra Vinh|Tuyen Quang|Vinh Long|Vinh Phuc|Yen Bai';
    this.s_a[244] = 'Saint Croix|Saint John|Saint Thomas';
    this.s_a[245] = 'Blaenau Gwent|Bridgend|Caerphilly|Cardiff|Carmarthenshire|Ceredigion|Conwy|Denbighshire|Flintshire|Gwynedd|Isle of Anglesey|Merthyr Tydfil|Monmouthshire|Neath Port Talbot|Newport|Pembrokeshire|Powys|Rhondda Cynon Taff|Swansea|The Vale of Glamorgan|Torfaen|Wrexham';
    this.s_a[246] = 'Alo|Sigave|Wallis';
    this.s_a[247] = 'West Bank';
    this.s_a[248] = 'Western Sahara';
    this.s_a[249] = '\'Adan|\'Ataq|Abyan|Al Bayda\'|Al Hudaydah|Al Jawf|Al Mahrah|Al Mahwit|Dhamar|Hadhramawt|Hajjah|Ibb|Lahij|Ma\'rib|Sa\'dah|San\'a\'|Ta\'izz';
    this.s_a[250] = 'Kosovo|Montenegro|Serbia|Vojvodina';
    this.s_a[251] = 'Central|Copperbelt|Eastern|Luapula|Lusaka|North-Western|Northern|Southern|Western';
    this.s_a[252] = 'Bulawayo|Harare|ManicalandMashonaland Central|Mashonaland East|Mashonaland West|Masvingo|Matabeleland North|Matabeleland South|Midlands';
    this.popData = false;
    this.perspective = { id: '', name: '', createdOn: '', weighting: 0, companyID: '', createdBy: '', createdById: '', unit: '' };
  
    this.objective = { name: '', createdOn: '', id: '',unit: '',description: '',companyID: '',createdBy: '', createdById: '', perspectiveID: '',perspectiveName: '' };

    this.userChampion = {
      name: '', id: '', email: '', bus_email: '', phoneNumber: '', photoURL: '', address: '', nationalId: '',
      nationality: ''
    };
    this.setSubsection = {
      id: '', no: 0, name: '', type: 'subSection', sectionNo: 0, sectionName: '', sectionId: '', projectId: '',
      projectName: '', companyId: '', companyName: '', Bills: []
    };
    this.companyWithProjectRoles = {
      name: '', IndustrialSectorDocument: '', id: '', location: '', bus_email: '', sector: '', participants: null, createdOn: '',
      targetAnnualIncome: '', logoURL: '', champion: this.userChampion, address: '', telephone: '', services: [], taxDocument: '', HnSDocument: '',
      by: '', byId: '', roles: [], updatedStatus: false, targetMonthlyIncome: '', actualMonthlyIncome: '', balanceSheet: '', actualAnnualIncome: ''
    };
    this.classification = { name: '', createdOn: '', plannedTime: '', actualTime: '', Varience: '', id: '' };
    this.section = {
      id: '', no: null, name: '', type: 'superSection', projectId: '', projectName: '', companyId: '', companyName: '',
      Bills: []
    }
    this.selectedProject = {
      name: '', type: '', by: '', byId: '', companyName: '', companyId: '', champion: this.userChampion,
      createdOn: '', id: '', location: '', sector: '', completion: ''
    };
    this.openBooksPrj = {
      name: '', type: '', by: '', byId: '', companyName: '', companyId: '', champion: this.userChampion,
      createdOn: '', id: '', location: '', sector: '', completion: '', invQuantity: { name: '', value: 0 }
    };
    this.selectedCompany = {
      name: '', IndustrialSectorDocument: '', createdOn: '', updatedStatus: false, id: '', bus_email: '', location: '', logoURL: '',
      participants: null, champion: this.userChampion, address: '', telephone: '', services: [], taxDocument: '', HnSDocument: '', by: '', byId: '',
      targetMonthlyIncome: '', actualMonthlyIncome: '', balanceSheet: '', actualAnnualIncome: '', targetAnnualIncome: '', sector: ''
    };
    this.projectCompDetail = { id: '', name: '' };
    this.newEnterprise = {
      name: '', IndustrialSectorDocument: '', createdOn: '', updatedStatus: false, id: '', bus_email: '', location: '', logoURL: '',
      participants: null, champion: null, address: '', telephone: '', services: [], taxDocument: '', HnSDocument: '', by: '', byId: '',
      targetMonthlyIncome: '', actualMonthlyIncome: '', balanceSheet: '', actualAnnualIncome: '', targetAnnualIncome: '', sector: ''
    };
    this.companystaff = {
      name: '', phoneNumber: '', by: '', byId: '', createdOn: '', email: '', bus_email: '', id: '', department: '',
      departmentId: '', photoURL: '', address: '', nationalId: '', nationality: '', hierarchy: '', supervisor: { name: '', id: '' }
    };
    this.department = { name: '', by: '', byId: '', companyName: '', companyId: '', createdOn: '', id: '', hod: null };
    this.employeeData = {
      name: '', phoneNumber: '', email: '', bus_email: '', id: '', address: '', nationalId: '', nationality: '',
      department: '', departmentId: '', photoURL: '', hierarchy: ''
    };
    this.labour = {
      name: '', id: '', email: '', bus_email: '', phoneNumber: '', photoURL: '', address: '', nationalId: '', cost: '',
      nationality: '', activeTime: [], levelOfEffort: 0, paymentRate: { rate: '', amount: 0 }, monthlyPay: 0
    };
    this.contact = {
      name: '', id: '', email: '', bus_email: '', phoneNumber: '', photoURL: '', address: '', nationalId: '',
      nationality: ''
    };
    this.task = {
      name: '', description: '', update: '', champion: this.companystaff, projectName: '', supervisor: this.projectCompDetail, toDos: [],
      department: '', startTime: '', finishTime: '', rate: '', perspectiveID: '', objectiveID: '', objective: '', perspective: '', type: { name: '', unit: '', rate: '', currency: '' }, UpdatedOn: '', selectedWeekWork: false, selectedWork: false,
      departmentId: '', startDate: '', endDate: '', by: '', createdOn: '', projectId: '', byId: '', projectType: '', champType: 'individualTask',
      companyName: '', companyId: '', trade: '', section: null, complete: false, id: '', participants: [], status: '', docs: [], equipment: {}, year: new Date().getFullYear().toString(),
      selectedWeekly: false, classification: null, unit: '', workStatus: '', targetQty: '', actualData: [], actualQty: 0, amount: 0, workHours: [], minimumScore: '70', source: '', plannedController: ''
    };
    this.dpt = { name: '', by: '', byId: '', companyName: '', companyId: '', createdOn: '', id: '', hod: null };
    this.asset = { name: '', assetNumber: '', by: '', byId: '', companyName: '', companyId: '', createdOn: '', cost: '' };
    this.client = {
      name: '', id: '', contactPerson: null, champion: null, by: '', byId: '', joinedOn: '', createdOn: '', address: '', logoURL: '', srTag: '',
      telephone: '', location: '', sector: '', services: [], taxDocument: '', HnSDocument: '', IndustrialSectorDocument: '', managers: [], projects: []
    };
    this.subsidiary = {
      name: '', IndustrialSectorDocument: '', createdOn: '', updatedStatus: false, id: '', bus_email: '', location: '', logoURL: '',
      participants: null, champion: null, address: '', telephone: '', services: [], taxDocument: '', HnSDocument: '', by: '', byId: '',
      targetMonthlyIncome: '', actualMonthlyIncome: '', balanceSheet: '', actualAnnualIncome: '', targetAnnualIncome: '', sector: '',
      Holding_companyName: '', companyId: ''
    };
    this.workItem = {
      uid: '', id: '', name: '', unit: '', description: '', quantity: null, targetQty: null, rate: null, workHours: null,
      amount: null, by: '', byId: '', type: '', champion: this.userChampion, classification: this.classification, participants: null,
      departmentName: '', departmentId: '', billID: '', billName: '', projectId: '', projectName: '', createdOn: '', UpdatedOn: '',
      actualData: null, workStatus: null, complete: false, start: null, end: null, startWeek: '', startDay: '', startDate: '', endDay: '',
      endDate: '', endWeek: '', taskName: '', taskId: '', companyId: '', companyName: '', classificationName: '', classificationId: '',
      selectedWork: false, section: this.section, actualStart: '', actualEnd: '', Hours: '', selectedWeekWork: false, selectedWeekly: false,
      championName: '', championId: ''
    };
    this.abridgedBill = {
      section: this.section, id: '', name: '', No: 1, projectId: '', projectName: '', companyId: '', companyName: '',
      totalAmount: null, createdOn: '', UpdatedOn: ''
    };
    this.initColUser = {
      name: '', gender: '', dob: '', age: 0, username: '', email: '', bus_email: '', phoneNumber: '', telephone: null,
      address: '', nationalId: '', nationality: '', zipCode: null, country: '', city: '', by: '', byId: '', companyName: '', companyId: '',
      createdOn: '', id: '', aboutMe: '', profession: null, qualifications: null, bodyWeight: 0, bodyHeight: 0, bodyMassIndex: 0,
      industrySector: '', personalAssets: null, personalLiabilities: null, reference: null, focusFactor: 0, userImg: '', LastTimeLogin: '',
      referee: [null], hierarchy: '', updated: false, totalIncome: '', estimatedMonthlyIncome: '', networth: ''
    };
    this.BalanceSheet = {
      name: '', id: '', createdOn: '', updatedOn: '',
      startDate: '', endDate: '', createdBy: null, TCS: 0, TNCS: 0, TAS: 0, TCL: 0, TNCL: 0,
      TLB: 0, TEquity: 0, lastUpdate: '', CS: [], NCS: [], CL: [], NCL: [], EQUITY: []
    }
    this.newCS = {
      name: '', value: 0, createdOn: '', Date: '',
      id: '', createdBy: null
    }; this.newEq = {
      name: '', value: 0, createdOn: '', Date: '',
      id: '', createdBy: null
    }; this.newNCL = {
      name: '', value: 0, createdOn: '', Date: '',
      id: '', createdBy: null
    }; this.newCL = {
      name: '', value: 0, createdOn: '', Date: '',
      id: '', createdBy: null
    }; this.newNCS = {
      name: '', value: 0, createdOn: '', Date: '',
      id: '', createdBy: null
    };
    // ------ IS ------
    
    const st = String(moment().year()) + '-' + String(1 + moment().month()) + '-01';
    const end = String(moment().year()) + '-' + String(1 + moment().month()) + '-' + String(moment().daysInMonth());
    this.IS = {
      name: String(moment().format('MMMM')),
      id: String(moment().format('MMMM')), createdOn: new Date().toISOString(), updatedOn: new Date().toISOString(),
      createdBy: this.userChampion,
      startDate: st, endDate: end,
      sales: { name: 'Revenue', value: 0, description: 'income', ds: 'revenue' },
      costofSales: { name: 'Cost of Sales', value: 0, description: 'Expenditure', ds: 'revenue' },
      grossProfit: { name: 'Gross Profit', value: 0, description: 'Total', ds: 'revenue' },
      financeCost: { name: 'Finance costs', value: 0, description: 'Expenditure', ds: 'costs' },
      totalInc: { name: 'Total Income', value: 0, description: 'Expenditure', ds: 'costs' },
      exchange_gain: { name: 'Exchange Gain', value: 0, description: 'Income', ds: 'income' },
      interestReceivable: { name: 'Interest Receivable', value: 0, description: 'Income', ds: 'income' },
      staffcost: { name: 'Staff costs', value: 0, description: 'Expenditure', ds: 'costs' },
      distributionCosts: { name: 'Distribution costs', value: 0, description: 'Expenditure', ds: 'costs' },
      administrationCosts: { name: 'Administration costs', value: 0, description: 'Expenditure', ds: 'costs' },
      OPExpense: { name: 'Operating Expense', value: 0, description: 'Expenditure', ds: 'costs' },
      profitbeforeIDA: {
        name: 'Profit before interest, depreciation and amortisation', value: 0, description: 'income',
        ds: 'plbda'
      },
      depreciation: { name: 'Depreciation', value: 0, description: 'Expenditure', ds: 'plbda' },
      AIA: { name: 'Amortisation of intangible assets', value: 0, description: 'Expenditure', ds: 'plbda' },
      profitbeforeIntTax: { name: 'Profit before interest and taxation', value: 0, description: 'income', ds: 'plbit' },
      InterestIncome: { name: 'Interest income', value: 0, description: 'income', ds: 'plbit' },
      InterestExpense: { name: 'Interest expense', value: 0, description: 'Expenditure', ds: 'plbit' },
      profitbeforeTax: { name: 'Profit before taxation', value: 0, description: 'income', ds: 'plb' },
      TaxExpense: { name: 'Taxation expense', value: 0, description: 'Expenditure', ds: 'plb' },
      profitafterTax: { name: 'Profit/(loss) after tax', value: 0, description: 'Total', ds: 'pAt' },
      IfEAI: { name: 'Income from equity accounted investments', value: 0, description: 'Total', ds: 'pAt' },
      ProfitOfYearCO: { name: 'Profit for the year from continuing operations', value: 0, description: 'Total', ds: 'py' },
      PLDO: { name: '(Loss)/profit from discontinued operations', value: 0, description: 'Total', ds: 'py' },
      ProfitOfYear: { name: 'Profit for the year', value: 0, description: 'Total', ds: 'py' },
    }
    this.CF = {
      name: '',
      id: '', createdOn: '', updatedOn: '', createdBy: null,
      startDate: '', endDate: '',
      RC: { name: 'Receipts from customers', value: 0, description: 'inFlow' },
      PSE: { name: 'Payments to suppliers and employees', value: 0, description: 'outFlow' },
      CGO: { name: 'Cash generated from operations', value: 0, description: 'isTotal' },
      IR: { name: 'Interest received', value: 0, description: 'inFlow' },
      IP: { name: 'Interest paid', value: 0, description: 'outFlow' },
      TaxationPaid: { name: 'Taxation paid', value: 0, description: 'outFlow' },
      OCF: { name: 'Cash generated from operations', value: 0, description: 'isTotal' },
      DPO: { name: 'Dividends paid to owners', value: 0, description: 'outFlow' },
      DPNI: { name: 'Dividends paid to non-controlling interests', value: 0, description: 'outFlow' },
      NCOP: { name: 'Net cash inflow from operating activities', value: 0, description: 'outFlow' },
      PIPPE: { name: 'Purchase of property, plant and equipment', value: 0, description: 'outFlow' },
      ER: { name: 'Equipment - Replacements', value: 0, description: 'outFlow' },
      EA: { name: 'Equipment - Additions', value: 0, description: 'outFlow' },
      PDPPE: { name: 'Proceeds on disposal of property, plant and equipment', value: 0, description: 'outFlow' },
      IJV: { name: 'Investment in joint venture', value: 0, description: 'inFlow' },
      PIAOG: { name: 'Purchase of intangible assets other than goodwill', value: 0, description: 'outFlow' },
      PDB: { name: 'Proceeds on disposal of business', value: 0, description: 'outFlow' },
      CRAB: { name: 'Cash related to acquisition of businesses', value: 0, description: 'outFlow' },
      DRAC: { name: 'Dividends received from associate companies', value: 0, description: 'inFlow' },
      DRJVC: { name: 'Dividends received from joint ventures classified as held-for-sale', value: 0, description: 'isTotal' },
      AoB: { name: 'Acquisition of businesses', value: 0, description: 'outFlow' },
      PDA: { name: 'Proceeds on disposal of assets held-for-sale', value: 0, description: 'outFlow' },
      CRA: { name: 'Cash related to assets held-for-sale', value: 0, description: 'outFlow' },
      PRI: { name: 'Proceeds from realisation of investment', value: 0, description: 'outFlow' },
      other: { name: 'Other', value: 0, description: 'isTotal' },
      NCOIA: { name: 'Net cash outflow from investing activities', value: 0, description: 'isTotal' },
      NATS: { name: 'Net acquisition of treasury shares', value: 0, description: 'isTotal' },
      NMB: { name: 'Net movement in borrowings', value: 0, description: 'inFlow' },
      NCFFA: { name: 'Net cash outflow from financing activities', value: 0, description: 'isTotal' },
      TDNCCE: { name: 'Total decrease in net cash and cash equivalents', value: 0, description: ' outFlow' },
      NCCEBY: { name: 'Net cash and cash equivalents at the beginning of the year', value: 0, description: 'inFlow' },
      EoER: { name: 'Effect of exchange rates', value: 0, description: 'isTotal' },
      NCCEEY: { name: 'Net cash and cash equivalents at the end of the year', value: 0, description: 'isTotal' },
    }

    this.networth = {
      name: '',
      id: '', createdOn: '', updatedOn: '', createdBy: null, startDate: '', endDate: '',
      openBal: {
        name: 'Openning NetWorth Balance', value: 0
      },
      NetProfit: {
        name: 'NetProfit for this Period', value: 0
      },
      NRG: {
        name: 'Networth Revaluation  Gain for This Period', value: 0
      },
      CloseBal: {
        name: 'Netwroth Closing Balance', value: 0
      },
    }

    this.Equity = {
      name: '',
      id: '', createdOn: '', updatedOn: '', createdBy: null, startDate: '', endDate: '',
      bal: {
        name: 'Balance', SC: { name: 'Shared Capital', value: 0 }, HTR: { name: 'Hedging and Translation reserve', value: 0 },
        OCR: { name: 'Other capital reserves', value: 0 }, RE: { name: 'Retained Earnings', value: 0 },
        Attr: { name: 'Attributable to owners', value: 0 }, NCI: { name: 'Non-controlling interests', value: 0 }, Tot: 0
      },
      TotCIY: {
        name: 'Total comprehensive income/(loss) for the year', SC: { name: 'Shared Capital', value: 0 },
        HTR: { name: 'Hedging and Translation reserve', value: 0 }, OCR: { name: 'Other capital reserves', value: 0 },
        RE: { name: 'Retained Earnings', value: 0 }, Attr: { name: 'Attributable to owners', value: 0 },
        NCI: { name: 'Non-controlling interests', value: 0 }, Tot: 0
      },
      TSA: {
        name: 'Treasury shares acquired (net)', SC: { name: 'Shared Capital', value: 0 },
        HTR: { name: 'Hedging and Translation reserve', value: 0 }, OCR: { name: 'Other capital reserves', value: 0 },
        RE: { name: 'Retained Earnings', value: 0 }, Attr: { name: 'Attributable to owners', value: 0 },
        NCI: { name: 'Non-controlling interests', value: 0 }, Tot: 0
      },
      TRE: {
        name: 'Transfer to retained earnings', SC: { name: 'Shared Capital', value: 0 },
        HTR: { name: 'Hedging and Translation reserve', value: 0 }, OCR: { name: 'Other capital reserves', value: 0 },
        RE: { name: 'Retained Earnings', value: 0 }, Attr: { name: 'Attributable to owners', value: 0 },
        NCI: { name: 'Non-controlling interests', value: 0 }, Tot: 0
      },
      USPR: {
        name: 'Utilisation of share-based payment reserve', SC: { name: 'Shared Capital', value: 0 },
        HTR: { name: 'Hedging and Translation reserve', value: 0 }, OCR: { name: 'Other capital reserves', value: 0 },
        RE: { name: 'Retained Earnings', value: 0 }, Attr: { name: 'Attributable to owners', value: 0 },
        NCI: { name: 'Non-controlling interests', value: 0 }, Tot: 0
      },
      RSBP: {
        name: 'Recognition of share-based payment', SC: { name: 'Shared Capital', value: 0 },
        HTR: { name: 'Hedging and Translation reserve', value: 0 }, OCR: { name: 'Other capital reserves', value: 0 },
        RE: { name: 'Retained Earnings', value: 0 }, Attr: { name: 'Attributable to owners', value: 0 }, NCI: { name: 'Non-controlling interests', value: 0 },
        Tot: 0
      },
      DDP: {
        name: 'Dividends declared and paid1', SC: { name: 'Shared Capital', value: 0 },
        HTR: { name: 'Hedging and Translation reserve', value: 0 }, OCR: { name: 'Other capital reserves', value: 0 },
        RE: { name: 'Retained Earnings', value: 0 }, Attr: { name: 'Attributable to owners', value: 0 },
        NCI: { name: 'Non-controlling interests', value: 0 }, Tot: 0
      },
      DDPCo: {
        name: 'Dividends declared and paid1',
        SC: { name: 'Shared Capital', value: 0 }, HTR: { name: 'Hedging and Translation reserve', value: 0 }, OCR: { name: 'Other capital reserves', value: 0 },
        RE: { name: 'Retained Earnings', value: 0 }, Attr: { name: 'Attributable to owners', value: 0 }, NCI: { name: 'Non-controlling interests', value: 0 },
        Tot: 0
      },
      newBal: {
        name: 'Balance', SC: { name: 'Shared Capital', value: 0 }, HTR: { name: 'Revaluation', value: 0 }, OCR: { name: 'Revaluation', value: 0 },
        RE: { name: 'Retained Earnings', value: 0 }, Attr: { name: 'Revaluation', value: 0 }, NCI: { name: 'Revaluation', value: 0 }, Tot: 0
      },
    }
    this.academics = { description: '', institution: '', period: { start: '', finish: '' }, courses: [] }
    this.profession = { description: '', institution: '', period: { start: '', finish: '' }, courses: [] }
    this.dpt = { name: '', by: '', byId: '', companyName: '', companyId: '', createdOn: '', id: '', hod: null };
    this.months = [
      'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
    ];
    this.stdPeriods = [
      { id: 'daily', name: 'Daily' }, { id: 'weekly', name: 'Weekly' }, { id: 'monthly', name: 'Monthly' },
      { id: 'quarterly', name: 'Quarterly' }, { id: 'yearly', name: 'Yearly' }
    ];
    this.currencyCodes = ["AED", "AFN", "ALL", "AMD", "ANG", "AOA", "ARS", "AUD", "AWG", "AZN", "BAM", "BBD", "BDT", "BGN", "BHD", "BIF", "BMD", "BND", "BOB", "BOV", "BRL", "BSD", "BTN", "BWP", "BYR", "BZD", "CAD", "CDF", "CHE", "CHF", "CHW", "CLF", "CLP", "CNY", "COP", "COU", "CRC", "CUC", "CUP", "CVE", "CZK", "DJF", "DKK", "DOP", "DZD", "EGP", "ERN", "ETB", "EUR", "FJD", "FKP", "GBP", "GEL", "GHS", "GIP", "GMD", "GNF", "GTQ", "GYD", "HKD", "HNL", "HRK", "HTG", "HUF", "IDR", "ILS", "INR", "IQD", "IRR", "ISK", "JMD", "JOD", "JPY", "KES", "KGS", "KHR", "KMF", "KPW", "KRW", "KWD", "KYD", "KZT", "LAK", "LBP", "LKR", "LRD", "LSL", "LTL", "LVL", "LYD", "MAD", "MDL", "MGA", "MKD", "MMK", "MNT", "MOP", "MRO", "MUR", "MVR", "MWK", "MXN", "MXV", "MYR", "MZN", "NAD", "NGN", "NIO", "NOK", "NPR", "NZD", "OMR", "PAB", "PEN", "PGK", "PHP", "PKR", "PLN", "PYG", "QAR", "RON", "RSD", "RUB", "RWF", "SAR", "SBD", "SCR", "SDG", "SEK", "SGD", "SHP", "SLL", "SOS", "SRD", "SSP", "STD", "SYP", "SZL", "THB", "TJS", "TMT", "TND", "TOP", "TRY", "TTD", "TWD", "TZS", "UAH", "UGX", "USD", "USN", "USS", "UYI", "UYU", "UZS", "VEF", "VND", "VUV", "WST", "XAF", "XAG", "XAU", "XBA", "XBB", "XBC", "XBD", "XCD", "XDR", "XFU", "XOF", "XPD", "XPF", "XPT", "XTS", "XXX", "YER", "ZAR", "ZWL"];

    this.professions = [
      "Academic librarian", "Accountant", "Accounting technician", "Actuary", "Adult nurse", "Advertising account executive", "Advertising account planner", "Advertising copywriter", "Advice worker", "Advocate (Scotland)", "Aeronautical engineer", "Agricultural consultant", "Agricultural manager", "Aid worker/humanitarian worker", "Air traffic controller", "Airline cabin crew", "Amenity horticulturist", "Analytical chemist", "Animal nutritionist", "Animator", "Archaeologist", "Architect", "Architectural technologist", "Archivist", "Armed forces officer", "Aromatherapist", "Art therapist", "Arts administrator", "Auditor", "Automotive engineer", "Barrister", "Barrister’s clerk", "Bilingual secretary", "Biomedical engineer", "Biomedical scientist", "Biotechnologist", "Brand manager", "Broadcasting presenter", "Building control officer/surveyor", "Building services engineer", "Building surveyor", "Camera operator", "Careers adviser (higher education)", "Careers adviser", "Careers consultant", "Cartographer", "Catering manager", "Charities administrator", "Charities fundraiser", "Chemical (process) engineer", "Child psychotherapist", "Children's nurse", "Chiropractor", "Civil engineer", "Civil Service administrator", "Clinical biochemist", "Clinical cytogeneticist", "Clinical microbiologist", "Clinical molecular geneticist", "Clinical research associate", "Clinical scientist - tissue typing", "Clothing and textile technologist", "Colour technologist", "Commercial horticulturist", "Commercial/residential/rural surveyor", "Commissioning editor", "Commissioning engineer", "Commodity broker", "Communications engineer", "Community arts worker", "Community education officer", "Community worker", "Company secretary", "Computer sales support", "Computer scientist", "Conference organiser", "Consultant", "Consumer rights adviser", "Control and instrumentation engineer", "Corporate banker", "Corporate treasurer", "Counsellor", "Courier/tour guide", "Court reporter/verbatim reporter", "Credit analyst", "Crown Prosecution Service lawyer", "Crystallographer", "Curator", "Customs officer", "Cyber security specialist", "Dance movement therapist", "Data analyst", "Data scientist", "Data visualisation analyst", "Database administrator", "Debt/finance adviser", "Dental hygienist", "Dentist", "Design engineer", "Dietitian", "Diplomatic service", "Doctor (general practitioner, GP)", "Doctor (hospital)", "Dramatherapist", "Economist", "Editorial assistant", "Education administrator", "Electrical engineer", "Electronics engineer", "Employment advice worker", "Energy conservation officer", "Engineering geologist", "Environmental education officer", "Environmental health officer", "Environmental manager", "Environmental scientist", "Equal opportunities officer", "Equality and diversity officer", "Ergonomist", "Estate agent", "European Commission administrators", "Exhibition display designer", "Exhibition organiser", "Exploration geologist", "Facilities manager", "Field trials officer", "Financial manager", "Firefighter", "Fisheries officer", "Fitness centre manager", "Food scientist", "Food technologist", "Forensic scientist", "Geneticist", "Geographical information systems manager", "Geomatics/land surveyor", "Government lawyer", "Government research officer", "Graphic designer", "Health and safety adviser", "Health and safety inspector", "Health promotion specialist", "Health service manager", "Health visitor", "Herbalist", "Heritage manager", "Higher education administrator", "Higher education advice worker", "Homeless worker", "Horticultural consultant", "Hotel manager", "Housing adviser", "Human resources officer", "Hydrologist", "Illustrator", "Immigration officer", "Immunologist", "Industrial/product designer", "Information scientist", "Information systems manager", "Information technology/software trainers", "Insurance broker", "Insurance claims inspector", "Insurance risk surveyor", "Insurance underwriter", "Interpreter", "Investment analyst", "Investment banker - corporate finance", "Investment banker – operations", "Investment fund manager", "IT consultant", "IT support analyst", "Journalist", "Laboratory technician", "Land-based engineer", "Landscape architect", "Learning disability nurse", "Learning mentor", "Lecturer (adult education)", "Lecturer (further education)", "Lecturer (higher education)", "Legal executive", "Leisure centre manager", "Licensed conveyancer", "Local government administrator", "Local government lawyer", "Logistics/distribution manager", "Magazine features editor", "Magazine journalist", "Maintenance engineer", "Management accountant", "Manufacturing engineer", "Manufacturing machine operator", "Manufacturing toolmaker", "Marine scientist", "Market research analyst", "Market research executive", "Marketing account manager", "Marketing assistant", "Marketing executive", "Marketing manager (social media)", "Materials engineer", "Materials specialist", "Mechanical engineer", "Media analyst", "Media buyer", "Media planner", "Medical physicist", "Medical representative", "Mental health nurse", "Metallurgist", "Meteorologist", "Microbiologist", "Midwife", "Mining engineer", "Mobile developer", "Multimedia programmer", "Multimedia specialists", "Museum education officer", "Museum/gallery exhibition officer", "Music therapist", "Nanoscientist", "Nature conservation officer", "Naval architect", "Network administrator", "Nurse", "Nutritional therapist", "Nutritionist", "Occupational therapist", "Oceanographer", "Office manager", "Operational researcher", "Orthoptist", "Outdoor pursuits manager", "Packaging technologist", "Paediatric nurse", "Paramedic", "Patent attorney", "Patent examiner", "Pension scheme manager", "Personal assistant", "Petroleum engineer", "Pharmacist", "Pharmacologist", "Pharmacovigilance officer", "Photographer", "Physiotherapist", "Picture researcher", "Planning and development surveyor", "Planning technician", "Plant breeder", "Police officer", "Political party agent", "Political party research officer", "Practice nurse", "Press photographer", "Press sub-editor", "Prison officer", "Private music teacher", "Probation officer", "Product development scientist", "Production manager", "Programme researcher", "Project manager", "Psychologist (clinical)", "Psychologist (educational)", "Psychotherapist", "Public affairs consultant (lobbyist)", "Public affairs consultant (research)", "Public house manager", "Public librarian", "Public relations (PR) officer", "QA analyst", "Quality assurance manager", "Quantity surveyor", "Records manager", "Recruitment consultant", "Recycling officer", "Regulatory affairs officer", "Research chemist", "Research scientist", "Restaurant manager", "Retail banker", "Retail buyer", "Retail manager", "Retail merchandiser", "Retail pharmacist", "Sales executive", "Sales manager", "Scene of crime officer", "Secretary", "Seismic interpreter", "Site engineer", "Site manager", "Social researcher", "Social worker", "Software developer", "Soil scientist", "Solicitor", "Speech and language therapist", "Sports coach", "Sports development officer", "Sports therapist", "Statistician", "Stockbroker", "Structural engineer", "Systems analyst", "Systems developer", "Tax inspector", "Teacher (nursery/early years)", "Teacher (primary)", "Teacher (secondary)", "Teacher (special educational needs)", "Teaching/classroom assistant", "Technical author", "Technical sales engineer", "TEFL/TESL teacher", "Television production assistant", "Test automation developer", "Tour operator", "Tourism officer", "Tourist information manager", "Town and country planner", "Toxicologist", "Trade union research officer", "Trader", "Trading standards officer", "Training and development officer", "Translator", "Transportation planner", "Travel agent", "TV/film/theatre set designer", "UX designer", "Validation engineer", "Veterinary nurse", "Veterinary surgeon", "Video game designer", "Video game developer", "Volunteer work organiser", "Warehouse manager", "Waste disposal officer", "Water conservation officer", "Water engineer", "Web designer", "Web developer", "Welfare rights adviser", "Writer", "Youth worker"
    ];
  }

  initAcademis() { return this.academics; }
  initProfession() { return this.academics; }
  getClassInit() { return this.classification; }
  initAsset() { return this.asset }
  initContact() { return this.contact }
  getNetworth() { return this.networth };
  getEQ() { return this.Equity };
  getBS() { return this.BalanceSheet };
  getIS() { return this.IS };
  getCF() { return this.CF };
  initSubsection() { return this.setSubsection; }
  getSectionInit() { return this.section };
  initColUserData() { return this.initColUser };
  initCompwithRoles() { return this.companyWithProjectRoles };
  getEmployeeDataInit() { return this.employeeData };
  getSubsidiary() { return this.subsidiary };
  getTask() { return this.task };
  getClient() { return this.client };
  getSelectedStaff() { return this.selectedStaff };
  initLabour() { return this.labour };
  getSelectedProject() { return this.selectedProject };
  getSelectedCompany() { return this.selectedCompany };
  getnewEnterprise() { return this.newEnterprise };
  getCompChampion() { return this.compChampion };
  getUserChampion() { return this.userChampion };
  getWorkItem() { return this.workItem };
  getAbridgedBill() { return this.abridgedBill };
  getDeptInit() { return this.dpt };
  setPopup(data) { this.popData = data };
  getPopup() { return this.popData = false };
  initDept() { return this.department; }
  initPerspective() { return this.perspective };
  initObjective() { return this.objective };
  openLgg(template: TemplateRef<any>) {
      this.modalRef2 = this.modalService.open(template, { size: 'lg' })
  }

  isMob() {
    // if (window.innerWidth < 991) {}
    if (window.outerWidth < 991) {
      return false;
    } else{
      return true;
    }
  }

  winH() {
    const h = String(window.innerHeight / 12)+'em'; 
    console.log(h);
    return h;
  }

  winVidH() {
    if(this.isMob()){
    const h = window.innerHeight - ((1/3)*(window.innerHeight)); 
      return h
    } else {
    const h = (4/5)*window.innerHeight; 
      return h;
    }
  }

  scrollMax() {
    const res = this.winDisplay();
    if(!this.isMob()){
      return '61.5vmax';
    } else {
      if(res.innerWidth >= 1920) {
        return '27.5vmax';
      } else {
        return '18.5vmax';
      }
    }
  }


  winVidW() {
    const w = window.innerWidth - ((1/3)*(window.innerWidth)); 
    if(this.isMob()){
      return w;
    } else {
      return window.innerWidth;
    }
  }

  pubRes() {
    const res = this.winDisplay();
    if(res.innerWidth >= 1920) {
      return '86px';
    } else {
      return '53px';
    }
  }

  dashRes() {
    const res = this.winDisplay();
    if(res.innerWidth >= 1920) {
      return true;
    } else {
      return false;
    }
  }
  
  pubDashSpacer() {
    const res = this.winDisplay();
    if(res.innerWidth >= 1920) {
      return '15em';
    } else {
      return '4em';
    }
  }

  checkOrient(){
    if(window.orientation === 0) {
      this.ns.showNotification('change-orient', 'top', 'right', 'change-orient');
    }
  }

  modalheight() {
    const res = this.winDisplay();
    if(res.innerWidth >= 1920) {
      return '73vh';
    } else {
      return '53vh';
    }
  }
  
  pubPrdSpacer() {
    if(!this.isMob()) {
      return '5em';
    } else {
      const res = this.winDisplay();
      if(res.innerWidth >= 1920) {
        return '1em';
      } else {
        return '2em';
      }
    }
  }

  pubMobempty() {
    if(!this.isMob()) {
      return '28.5vmax';
    } else {
      const res = this.winDisplay();
      if(res.innerWidth >= 1920) {
        return '2em';
      } else {
        return '1em';
      }
    }
  }

  resultsfew(x) {
    if(this.isMob()) {
      return '27em'
    } else {
      const res = this.winDisplay();
      if(res.innerWidth >= 1920) {
        return '2em';
      } else {
        return this.size(x);
      }
    }
  }

  size(x) {
    if (x === 1) {
      return '49.5vmax';
    } else {
      let xc = String((10 - x)*4) +'em';
      console.log(x, xc);
      return xc;
    }
  }

  pubPrdSpaceSearch() {
    const res = this.winDisplay();
    if(res.innerWidth >= 1920) {
      return '4em';
    } else {
      return '1em';
    }
  }

  barSize(n) {
    const res = this.winDisplay();
    if(!this.isMob()){
      if(res.innerWidth >= 1920) {
        if (n <= 5) {
          return '30em';
        } else {
          return String((n * 5) * 2)+'em'
        }
      } else {
        if (n <= 5) {
          return '20em';
        } else {
          return String((n * 3) * 2)+'em'
        }
      }
    } else {
        if (n <= 10) {
          return '67em';
        } else {
          return String(n * 5)+'em'
        }
      
    }
  }
  
  pbFoot() {
    const res = this.winDisplay();
    if(res.innerWidth >= 1920) {
      return '16px';
    } else {
      return '8px';
    }
  }

  titleSize() {
    const res = this.winDisplay();
    if(res.innerWidth >= 1920) {
      return 'col-8';
    } else {
      return '';
    }
  }

  titlefont() {
    const res = this.winDisplay();
    if(this.isMob()){
      if(res.innerWidth >= 1920) {
        return '87px';
      } else { 
        return '66px';
      }
    } else {
      return '41px';
    }
  }

  tempLoad() {
    const res = this.winDisplay();
    if(this.isMob()){
      if(res.innerWidth >= 1920) {
        return '49em !important';
      } else { 
        return '28em !important';
      }
    } else {
      return '28em !important';
    }
  }
  
  tempText() {
    const res = this.winDisplay();
    if(this.isMob()){
      if(res.innerWidth >= 1920) {
        return true;
      } else { 
        return false;
      }
    } else {
      return false;
    }
  }

  callSnapshot(x: AngularFirestoreCollection<any>) {
    return x.snapshotChanges().pipe(map((b) =>
      b.map((a) => {
        const data = a.payload.doc.data() as any;
        data.setid = a.payload.doc.id;
        return data;
      }))
    )
  }

  
  timelineScroll() {
    const res = this.winDisplay();
    if(this.isMob()){
      if(res.innerWidth >= 1920) {
        return '44vmax !important';
      } else { 
        return '57vmax !important';
      }
    } else {
      return false;
    }
  }
  
  tubetitle() {
    const res = this.winDisplay();
    if(this.isMob()){
      return '60px';
    } else {
      return '47px';
    }
  }

  resultsfont() {
    if(this.isMob()){
        return '66px';
    } else {
      return '19px';
    }
  }

  bodyHeigt() {
    const res = this.winDisplay();
    if(res.innerWidth >= 1920) {
      return '67em';
    } else {
      return '48';
    }
  }

  pubPrdSpaceOne() {
    const res = this.winDisplay();
    if(res.innerWidth >= 1920) {
      return '12em';
    } else {
      return '3em';
    }
  }

  nString(x) {
    console.log(x);
    return String(x);
  }

  nNumber(x) {
    console.log(x);
    return Number(x);
  }
  
  winDisplay(): {innerWidth, innerHeight} {
    const h = {
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth
    }
    return h;
  }

  width(): {innerWidth: string, innerHeight: string, outerHeight: string, outerWidth: string} {
    const h = {
      innerHeight: String(window.innerHeight)+'px',
      innerWidth: String(window.innerWidth)+'px',
      outerHeight: String(window.outerHeight)+'px',
      outerWidth: String(window.outerWidth - (20%window.outerWidth))+'px'
    }
    return h;
  }

  initType() {
    this.type = { value: '', verified: false, approved: false, amount: "", by: "", byId: "", companyId: "", companyName: "", createdBy: { name: '', id: ''},  createdOn: "", id: "",  name: "", rate: "", unit: "" };
    return { value: '', verified: false, approved: false, amount: "", by: "", byId: "", companyId: "", companyName: "", createdBy: { name: '', id: ''},  createdOn: "", id: "",  name: "", rate: "", unit: "" }
  }

  initCustomer(): customer {
    return {
      name: '', id: '', contactPerson: { name: '', phoneNumber: '', email: '', bus_email: '', id: '', address: '' }, champion: this.userChampion, by: '', byId: '', joinedOn: '', createdOn: '', address: '', logoURL: '',
      telephone: '', location: '', sector: '', services: [], projects: [], taxDocument: '', HnSDocument: '', IndustrialSectorDocument: '', managers: [], customerType: '', postalAddress: '', srTag: ''
    }
  }

  initInventory(): Product {
    return { name: '', description: '', project: { name: '', id: '' }, company: { name: '', id: '' }, footprint: [],  parent: '', contractSum: { name: '',  value: 0 }, rate:  { name: '', verified: false, approved: false },
    productNo:  { name: '', verified: false, approved: false }, size: { name: '', verified: false, approved: false }, prjQuantity : { value: 0, name: '' }, unit: { name: '', verified: false, approved: false },
    parties: [], party: { name: '', id: '' }, Amount: { cost: 0.00, paid: 0.00, balance: 0.00 }, SellStatus: { status: '', payment: '', customer: [], date: '', notes: ''}, type: { name: '', value: '', verified: false, approved: false }, entQuantity: { value: 0.00, name: '' }, id: '', participants: [], transAction: '', by:{ name: '', id: ''},
    initiated: { by: { name: '', id: '' }, status: false, date: '' }, checked: { by: { name: '', id: '' }, status: false, date: '' },  approved: { by: { name: '', id: '' }, status: false, date: '' }, createdOn: '', update: '' }
  }

  initAgentInventory(): agentProduct {
    return { name: '', description: '', agent: { allocationDate: '' , reAllocationDate: '' , name: '', id: '' },
    project: { name: '', id: '' }, company: { name: '', id: '' }, footprint: [],  parent: '', contractSum: { name: '',  value: 0 }, rate:  { name: '', verified: false, approved: false },
    productNo:  { name: '', verified: false, approved: false }, size: { name: '', verified: false, approved: false }, prjQuantity : { value: 0, name: '' }, unit: { name: '', verified: false, approved: false },
    parties: [], party: { name: '', id: '' }, Amount: { cost: 0.00, paid: 0.00, balance: 0.00 }, SellStatus: {}, type: { name: 'Property', value: 'Stand',  verified: false, approved: false }, entQuantity: { value: 0.00, name: '' }, id: '', participants: [], transAction: '', by:{ name: '', id: ''},
    initiated: { by: { name: '', id: '' }, status: false, date: '' }, checked: { by: { name: '', id: '' }, status: false, date: '' },  approved: { by: { name: '', id: '' }, status: false, date: '' }, createdOn: '', update: '' }
  }

  initEntInventory(): Product {
    return { name: '', description: '', project: { name: '', id: '' }, company: { name: '', id: '' }, footprint: [], parent: '', contractSum: { name: '', value: 0 }, rate:  { name: '', verified: false, approved: false },
     productNo:  { name: '', verified: false, approved: false }, size: { name: '', verified: false, approved: false }, prjQuantity : { value: 0, name: '' }, entQuantity : { value: 0, name: '' },
     unit: { name: '', verified: false, approved: false }, parties: [], party: { name: '', id: '' }, Amount: { cost: 0.00, paid: 0.00, balance: 0.00 }, SellStatus: {}, type: { name: '', value: '', verified: false, approved: false }, id: '', participants: [], transAction: '', by:{ name: '', id: ''},
    initiated: { by: { name: '', id: '' }, status: false, date: '' }, checked: { by: { name: '', id: '' }, status: false, date: '' },  approved: { by: { name: '', id: '' }, status: false, date: '' }, createdOn: '', update: ''  }
  }

  paymentMethods = [
      "Cash", "Product"
  ];

  rewriteData(worm, data) {
    if (data === "January") {
      return worm.replace(/January/g, '');
    }
    if (data === "February") {
      return worm.replace(/February/g, '');
    }
    if (data === "March") {
      return worm.replace(/March/g, '');
    }
    if (data === "April") {
      return worm.replace(/April/g, '');
    }
    if (data === "May") {
      return worm.replace(/May/g, '');
    }
    if (data === "June") {
      return worm.replace(/June/g, '');
    }
    if (data === "July") {
      return worm.replace(/July/g, '');
    }
    if (data === "August") {
      return worm.replace(/August/g, '');
    }
    if (data === "September") {
      return worm.replace(/September/g, '');
    }
    if (data === "October") {
      return worm.replace(/October/g, '');
    }
    if (data === "November") {
      return worm.replace(/November/g, '');
    }
    if (data === "December") {
      return worm.replace(/December/g, '');
    }
  }
  
  initRate() {
    return { name: '', id: '', unit: '', rate: '', by: '', byId: '', companyName: '', companyId: '', createdOn: '' };
  }

  initProd() {
    return { name: '', value: '', verified: false, approved: false, amount: '', by: '', byId: '', companyId: '', companyName: '', createdBy: { name: '', id: ''},  createdOn: '', id: '',  rate: '', unit: '' }
  }
  
  initPhase() {
    const ini: any = { name: '', id: '', unit: '', amount: null, createdOn: '' };
    return ini;
  }
  
  // ------------------ init financials -----------------

  
  print() {
    window.print();
  }
  goBack() {
    
    this.toolPlug = true;
    let titlee = this.location;
    window.history.back();
    console.log(this.toolPlug, titlee);
  }

  goBack2() {
    this.toolPlug = true;
    let titlee = this.location;
    window.history.back();window.history.back();
    console.log(this.toolPlug, titlee);
  }

  returnCur() {
    return this.currency;
      
  }

  goFox() {
    window.history.forward();
  }

  goTops() {
    window.scrollTo({ top: 0, behavior: 'smooth' });  
  }

  showModal() {
  }

  initTrans(): transaction {
    return { name: '', project: { name: '', id: '' }, by: { name: '', id: '' }, company: { name: '', id: '' }, product: this.initEntInventory(), parties: [], rate:  { name: '', verified: false, approved: false }, amount: { cost: '0.00', paid: 0.00, balance: 0.00, currency: '' }, transType: '', transClass: '', createdOn: '', date: '', noti: '', read: false, id: '', saleType: '' }
  }

  initDoc() : doc {
    return { 
      name: '',
      date: '',
      action: '',
      src: '',
      id: '',
      by: { id: '', name: ''}
    }
  }
  
  initSale(): compTans {
    return { name: '', project: { name: '', id: '' }, by: { name: '', id: '' }, company: { name: '', id: '' }, product: this.initEntInventory(), parties: [], rate:  { name: '', verified: false, approved: false }, amount: { cost: '0.00', paid: 0.00, balance: 0.00, currency: '' }, transType: '', transClass: '', createdOn: '', date: '', noti: '', read: false, id: '', saleType: '', component: 'Sale',
    paymentMethod: '', Initiated: {  by: { name: '', id: '' }, status: false, date: '' }, Checked: { by: { name: '', id: '' }, status: false, date: '' }, Approved: { by: { name: '', id: '' }, status: false, date: '' }, products: [], amountInLieu: '', quatityInLieu:  { value: '', unit: '' }, extrainfo: '' }
  }

  initCancelSale(): transCancel {
    return { name: '', project: { name: '', id: '' }, by: { name: '', id: '' }, company: { name: '', id: '' }, product: this.initEntInventory(), parties: [], rate:  { name: '', verified: false, approved: false }, amount: { cost: '0.00', paid: 0.00, balance: 0.00, currency: '' }, transType: '', transClass: '', createdOn: '', date: '', noti: '', read: false, id: '', saleType: '', component: 'Sale',
    paymentMethod: '', Initiated: {  by: { name: '', id: '' }, status: false, date: '' }, Checked: { by: { name: '', id: '' }, status: false, date: '' }, Approved: { by: { name: '', id: '' }, status: false, date: '' }, products: [], amountInLieu: '', quatityInLieu:  { value: '', unit: '' }, docs: [], extrainfo: '' }
  }
  
  initPrData() {
    return { id: '', getInventory: [], getTeams: [], getLabour: [], getClients: [], salesTrans: [], prjTrans: [], name: '', companyId: '', companyName: '', getProductTypes: of([]), getPhases: of([]), };
  }
  initTransPay(): compTans {
    return { name: '', project: { name: '', id: '' }, by: { name: '', id: '' }, company: { name: '', id: '' }, product: this.initEntInventory(), parties: [], rate:  { name: '', verified: false, approved: false }, amount: { cost: '0.00', paid: 0.00, balance: 0.00, currency: '' }, transType: '', transClass: '', createdOn: '', date: '', noti: '', read: false, id: '', saleType: '', component: 'Payement',
    paymentMethod: '', Initiated: {  by: { name: '', id: '' }, status: false, date: '' }, Checked: { by: { name: '', id: '' }, status: false, date: '' }, Approved: { by: { name: '', id: '' }, status: false, date: '' }, products: [], amountInLieu: '', quatityInLieu:  { value: '', unit: '' }, extrainfo: '' }
  }

  initRole() {
    return { name: '', createdBy: {}, createdOn: '' }
  }

  initOpenBksPrj() {
    return {
      name: '', type: '', by: '', byId: '', companyName: '', companyId: '', champion: this.userChampion, createdOn: '', id: '', location: '', sector: '', completion: '', invQuantity: { name: '', value: 0 }
    };
  }

  initPayment() { return this.payement };

  moneyString(amount) {
    if ((typeof amount !== 'number') && amount !== null) {
      if (amount?.includes('$')) {
        const num = this.numberForm(amount);
        return this.currencyPipe?.transform(Number(num), '$');
      } else {
        return this.currencyPipe?.transform(Number(amount), '$');
      }
    } else {
      return this.currencyPipe?.transform(amount, '$');
    }
  }

  numberForm(nbm) {
    if (typeof nbm === 'number') {
      return String(nbm).replace('$', '').replace('.00', '');
    } else if (typeof nbm === 'string') {
      nbm = nbm.replace(/\s/g,'');
      if (nbm.includes(' ') && nbm.includes(',')) {
        const ds = nbm.replace('$', '').replace('.00', '').replace(' ', '').replace(',', '');
        return ds;
      } else if (nbm.includes(' ')) {
        const ds = nbm.replace('$', '').replace('.00', '').replace(' ', '').replace(',', '');
        return ds;
      } else if (nbm.includes(',')){
        const ds = nbm.replace('$', '').replace('.00', '').replace(',', '');
        return ds;
      } else {
        const ds = nbm.replace('$', '').replace('.00', '').replace('', '');
        return ds;
      } 
    }
  }
  
  numberFormArch(nbm: string) {
    const count = (nbm.match(/,/g) || []).length;
    let word = nbm.replace('$', '').replace('.00', '')
    for (let index = 0; index < count; index++) {
      word = word.replace(',', '');
      if (index + 1 === count) {
        return word;
      }
    }
  }

  getUnicode(data) {
    const fndSI = (this.SIunits || this.allunits).find(si => si.id === data);
    if (fndSI) {
      return fndSI.unicode;
    } else {
      return data;
    }
  }

  getUnitname(data) {
    const fndSI = (this.SIunits || this.allunits).find(si => si.id === data);
    if (fndSI) {
      return fndSI.name;
    } else {
      return data;
    }
  }

  getCurrencyCode(data) {
    const fndSI = (this.currency).find(si => si.code === data);
    if (fndSI) {
      return fndSI.code;
    } else {
      return data;
    }
  }

  getCharacter(wrd: string) {
    if (wrd.length > 0) {
      let newWord = '';
      let i;
      while (wrd[i] !== '(') {
        newWord += wrd[i];
        return newWord;
      }
    }
  }
  
  getUniName(data) {
    console.log(data);
    const fndSI = (this.SIunits || this.allunits).find(si => si.id === data);
    if (fndSI) {
      console.log(fndSI);
      const newWord = fndSI.name;
      console.log(newWord);
      return newWord
    } else {
      return data
    }
  }

  getInvType(data) {
    const fndSI = this.inventoryTypes.find(si => si.id === data);
    if (fndSI) {
      console.log(fndSI);
      return fndSI.name+(fndSI.type)
    } else {
      return data
    }
  }

  transNumString(element) {
    element = this.currencyPipe.transform(element, '$');
    console.log(element);
    return element;
  }

  
  checkLegality() {
      this.clearView();
      return 'Coming Soon';
  }

  
  clearView() {
    setTimeout(() => {
      this.std.viewable = '';
      this.cus.viewable = '';
      this.supp.viewable = '';
      this.inv.viewable = '';
      this.sale.viewable = '';
      this.repApp.viewable = '';
      this.metApp.viewable = '';
      this.notApp.viewable = '';
      this.docApp.viewable = '';
    }, 4000);
  }

  dhms() {
    const d = new Date();
    d.getMilliseconds();
    const nHrs = Math.floor(d.getHours());
    const nMin = Math.floor(d.getMinutes());
    const nSecs = Math.floor(d.getSeconds());
    const millSecs = Math.floor(d.getMilliseconds());
    if (nSecs % 0.25 === 0) {
        this.randomColor = '#' + Math.floor(Math.random() * 16777215).toString(16);
        this.randomColor = this.randomColor;
        this.side = !this.side
    }
    this.time = [nHrs + ':', nMin + ':', nSecs].join(' ')
    return [nHrs + ':', nMin + ':', nSecs].join(' ');
  }

  getInitials(name) {
    const nuName = name.split(/(\s+)/).filter((x) => x.trim().length>0).length;
    console.log(name, nuName);
    const fullName = name.split(' ');
    const initials = fullName.shift()?.charAt(0) + fullName.pop()?.charAt(0);
    return initials.toUpperCase();
  }

  initInvoice(): Invoice {
    return {
      name: '', createdOn: '', by: {  name: '', id: '' },
      date: '',
      invNo: '',
      customer: [{ address: '', email: '', bus_email: '', name: '', phoneNumber: '', photoUrl: ''}],
      company: { address: '', name: '', id: '', telephone: '', logoURL: '', contact: {}, bank: { accountNo: '', branch: { name: '', code: '' }, address: '', swiftCode: '', currency: '' } },
      project: { name: '', id: '' },
      products: [],
      prevBalance: { value: 0, name: 'Previous Balance' }, totalBalanceDue: { value: 0, name: 'Total Balance Due' },
      payDueDate: { value: '', name: 'Payment Due Date' },
      id: '',
      newCharges: { date: '', value: 0, name: 'New Charges' },
      instalment: { date: '', value: 0, name: 'Monthly Instalment' },
      interest: [],
      totalAmount: { value: 0, name: 'Total Amount' },
      subTotal: { value: 0, name: 'Subtotal' },
      discount: { value: 0, name: 'Discount' },
      taxRate: { value: 0, name: 'Tax Rate', rate: 0 },
      total: { value: 0, name: 'Total' }, notes: ''
    }
  }
  
  initBanktasks() { 
    return { wksTasks: [], Upcoming: [], Outstanding: [], Current: [], ShortTerm: [], MediumTerm: [], LongTerm: [], allActions: [], };
  }

  initPrj(): Project {
    return {
      name: '',
      type: '',
      by: '',
      byId: '',
      companyName: '',
      companyId: '',
      createdOn: '',
      location: '',
      sector: '',
      champion: this.getCompChampion(),
      id: '',
      completion: ''
    }
  }

  ngOnInit(): void {
    $.fn.extend({
      print: function() {
        var frameName = 'printIframe';
        var doc = window.frames[frameName];
        if (!doc) {
          $('<iframe>').hide().attr('name', frameName).appendTo(document.body);
          doc = window.frames[frameName];
        }
        doc.document.body.innerHTML = this.html();
        doc.window.print();
        this.selected = false;
        return this;
      }
    });
  }

  printpart (x) {
    this.selected = true;
    setTimeout(() => {
      this.printDiv(x);
    }, 2000);
  }

  printDiv(divId: string) {
    const css = `<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.0/css/bootstrap.min.css"
    integrity="sha384-9gVQ4dYFwwWSjIDZnLEWnxCjeSWFphJiwGPXr1jddIhOegiu1FwO5qRGvFXOdJZ4" crossorigin="anonymous">`;
    const printContents = document.getElementById(divId).innerHTML;
    const pageContent = `<!DOCTYPE html><html><head>${css}</head><body onload="window.print()">${printContents}</html>`;
    let popupWindow: Window;
    if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
      popupWindow = window.open(
        '',
        '_blank',
        'width=600,height=600,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no'
      );
      popupWindow.window.focus();
      popupWindow.document.write(pageContent);
        popupWindow.document.close();
      popupWindow.onbeforeunload = event => {
        popupWindow.close();
      };
      popupWindow.onabort = event => {
        popupWindow.document.close();
        popupWindow.close();
      };
    } else {
      popupWindow = window.open('', '_blank', 'width=600,height=600');
      popupWindow.document.open();
      popupWindow.document.write(pageContent);
      popupWindow.document.close();
    }
    
  }

  isValidDate(dateString: string): boolean {
    const date = new Date(dateString);
    return !isNaN(date.getTime());
  }
  
}
